import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  activateViewport,
  getCurrentImage,
  getInitialZoom,
  getViewport,
  loadActiveViewport,
  setInvert,
  FlipHorizontally,
  FlipVertically,
  setToolOnActiveViewport,
  updateViewport,
  checkForLateralSeries,
  changeStack,
  updateOrientationMarkers,
  toggleReferenceLines,
  loadHeatMap,
  loadOutline,
  resizeViewport,
  setRotation,
  setRotationAbsolute,
  getViewportRotation,
  applyViewportStates,
  setStackPosition,
  getMPRViewport,
  rerenderViewport,
  resetViewPlaneOfCamera,
  performResize,
  resetRotation,
  resetStackPosition,
  getCurrentOuterIndex,
  setUserPreferredCineFps,
} from "../../helpers/CornerstoneViewportService";
import $ from "jquery";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import ImageScrollbar from "../Scrollbar/ImageScrollbar";
import MultiFrameToolbar from "../MultiFrameToolbar/MultiFrameToolbar";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import {
  DEFAULT_TOOL,
  HP_VIEWPORT_FLIP,
  LATERAL_VIEW_MODALITY_LIST,
  NONXRAYMODALITIES,
  REFLINES_SYNC_EXCLUDED_MODALITIES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  SYNC_EXCLUDED_MODALITIES,
  SYNC_MODES,
  TOAST_TYPE,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import PatientDetails from "../Overlays/PatientDetails";
import StudyDetails from "../Overlays/StudyDetails";
import SeriesDetails from "../Overlays/SeriesDetails";
import CalibrationBadge from "../Overlays/CalibrationBadge";
import DICOMDetails from "../Overlays/DICOMDetails";
import SCDICOMDetails from "../Overlays/SCDICOMDetails";
import ViewportSyncIndicator from "../Overlays/ViewportSyncIndicator";
import {
  Enums,
  utilities,
  cache,
  imageLoader,
} from "@cornerstonejs/core";
import {
  StackScrollTool,
  Enums as e,
  annotation
} from "@cornerstonejs/tools";
import MarkWarning from "../Overlays/MarkWarning/MarkWarning";
import {
  resetVOILUTRange,
  setVOILUTRange,
} from "../../helpers/WindowLevelUtility";
import { useTranslation } from "react-i18next";
import OrientationMarkers from "../Overlays/OrientationMarkers";
import TopLoader from "../../../../components/TopLoadingBar/TopLoader";
import loaderContext from "../../../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import { generateSRReport } from "../../helpers/SRModalityService";
import { parsePRFile, applyPRToViewport, getAllCachedPREntries, getPRAnnotatedImageIds, reapplyPRViewportState, removePRAnnotationsByUrl, getCachedPRData } from "../../helpers/PRModalityService";
import { parseKOFile, getAllCachedKOData } from "../../helpers/KOModalityService";
import ViewportNavWidget from "./ViewportNavWidget";
import {
  cine
} from "@cornerstonejs/tools/utilities";
import {
  getEngine,
} from "../../helpers/MultiFramePlaybackEngine";
import CINEMinus from "../../../../components/SVGComponents/Tools/CINEMinus";
import CINEPlus from "../../../../components/SVGComponents/Tools/CINEPlus";
import CINEPlaySmall from "../../../../components/SVGComponents/Tools/CINEPlaySmall";
import CINEPauseSmall from "../../../../components/SVGComponents/Tools/CINEPauseSmall";
import Impression from "../../../../components/SVGComponents/Tools/Impression";
import themeContext from "../../../../context/theme/ThemeContext";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../helpers/StackScrollSyncService";
import { isKeyImageAlreadyPresent } from "../../helpers/KeyImageUtility";
import {
  forceReinferenceImage,
  logViewOriginalImage,
} from "../../../../service/StudyViewerService";
import MobileOverlay from "../Overlays/MobileOverlay";
import Draggable from "react-draggable";
import Copy from "../../../../components/SVGComponents/Copy";
import toastContext from "../../../../context/toast/ToastContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import {
  resetOriginalImageState,
  extractSeriesDataFromDragEvent,
} from "../../helpers/ViewerHelperService";
import VDCMobileDetails from "../Overlays/VDCMobileDetails";
import { getToolGroupManager } from "../../helpers/CornerstoneService";
import * as cornerstonetools from "@cornerstonejs/tools";
import Spinner from "../../../../components/Spinner/Spinner";
import { isNonFrontalImagePresent } from "../../helpers/NonFrontalUtility";
import { prefetchData, registerThumbnailStack } from "../../helpers/CornerstoneThumbnailService";
import { uploadScDicom } from '../../../../service/StudyViewerService';
import { eventTarget, metaData as cornerstoneMetaData } from "@cornerstonejs/core";
import userContext from "../../../../context/users/UserContext";
import MaskImage from "../Overlays/MaskImage/MaskImage";
import { isImageAllowedToLLM } from "../../../../helpers/CommonUtility";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import { getEnv } from '../../../../helpers/EnvHelper';
import SpineLabellingTool from "../Tools/ToolComponents/SpineLabellingTool";

const SYNC_TARGET_IMAGE_LOADING_EVENT = "SYNC_TARGET_IMAGE_LOADING";

const Viewport = ({ viewportIndex, priors,setInitialVOI }) => {
  const { t } = useTranslation();
  const [viewportElement, setViewportElement] = useState(null);
  const [viewportModality, setViewportModality] = useState("");
  const [viewportProgress, setViewportProgress] = useState(0);
  const [viewportProgressComplete, setViewportProgressComplete] =
    useState(true);
  const [impressionHover, setImpressionHover] = useState(false);
  const [showKeyImageStar, setShowKeyImageStar] = useState(false);
  const {
    studyData,
    studyModality,
    viewportLoading,
    setViewportLoading,
    progress,
    setProgress,
    setProgressComplete,
    impressions,
    keyImages,
    priorStudyKeyImages,
    keyObjectImages,
    priorStudyKeyObjectImages,
    enableHeatmap,
    enableOutline,
    studyParentId,
    priorStudyData,
    studyBoundingBox,
    setAllLoadingComplete,
    sharedViewer,
    nonFrontalImages,
    setForceReinferenceImageIds,
    isHeatMapEnabled,
    setIsHeatMapEnabled,
    isOutlineEnabled,
    setIsOutlineEnabled,
    hpLoading, setHpLoading,
    showPathologyOptions,
    setShowPathologyOptions,
    setViewerOpacity,
    setShowTopBar,
    setShowSharedTopBar,
    hpDataList,
    isHPApplied,
    hpNotFound,
    
    setMaskImages,
    maskImages,
    cINEFramesPerSecond, setCINEFramesPerSecond,
    reportMenu,
    seriesMenu,
    setReportMenu,
    setSeriesMenu,
    setStudyPRAppliedCount,
    waitForScSeriesAndMerge,
  } = useContext(studyviewerContext);
  // Keep the multi-frame resolver's fallback FPS in sync with the user's cine
  // preference so it's honoured when a DICOM file carries no rate tags.
  useEffect(() => {
    setUserPreferredCineFps(cINEFramesPerSecond);
  }, [cINEFramesPerSecond]);
  const [viewportLoaded, setViewportLoaded] = useState(false);
  const [scrollImageLoadState, setScrollImageLoadState] = useState({
    loading: false,
    targetIndex: null,
    imageId: null,
  });
  const pendingScrollImageRef = useRef(null);
  const scrollLoaderDelayTimerRef = useRef(null);
  const lastUserScrollSourceRef = useRef({ viewportIndex: null, timestamp: 0 });
  // Tracks the last safeTargetIndex signalled per target viewport so we can
  // skip re-dispatching a loader when the target is already at that index
  // (e.g. source scrolled past boundary, mapping keeps clamping to max).
  const lastSignaledTargetIndexRef = useRef({});

  const clearScrollImageLoader = useCallback(() => {
    pendingScrollImageRef.current = null;
    if (scrollLoaderDelayTimerRef.current) {
      clearTimeout(scrollLoaderDelayTimerRef.current);
      scrollLoaderDelayTimerRef.current = null;
    }
    setScrollImageLoadState((prev) => {
      if (!prev.loading && prev.targetIndex === null && prev.imageId === null) {
        return prev;
      }
      return {
        loading: false,
        targetIndex: null,
        imageId: null,
      };
    });
  }, []);

  const [prAppliedCount, setPrAppliedCount] = useState(0);
  const [prCheckCount, setPrCheckCount] = useState(0);
  // Multi-PR list panel — one entry per PR file available in the study.
  const [prItems, setPrItems] = useState([]); // { url, description, creatorName, date, selected }
  // Mirror of prItems read inside the reactive PR effect — using a ref avoids
  // re-running the effect when the user toggles a PR (toggle handlers already
  // apply/remove imperatively), while still letting the effect respect the
  // latest selection state on slice changes.
  const prItemsRef = useRef([]);
  useEffect(() => { prItemsRef.current = prItems; }, [prItems]);
  // SOP Instance UID of the frame currently visible in the viewport.
  // Updated every time the user scrolls — drives the per-slice PR filter.
  const [currentSopUID, setCurrentSopUID] = useState(null);
  // PR viewport-state (zoom/pan/window) is scoped to the PR's own frame; the user's
  // own view on non-PR frames is tracked by userBaselineRef (declared below). See the
  // reactive PR effect + captureUserBaseline / restoreUserBaseline for the model.
  // Guards our OWN programmatic VOI/camera writes so their VOI_MODIFIED /
  // CAMERA_MODIFIED events aren't mistaken for user interaction.
  const programmaticViewportChangeRef = useRef(false);
  // Timestamp (ms) of the most recent programmatic viewport change. Cornerstone can
  // emit VOI_MODIFIED / CAMERA_MODIFIED asynchronously AFTER our programmatic write has
  // returned (post-render, on a later tick/rAF), so a boolean guard lowered on the next
  // macrotask is not enough. We also treat any VOI/camera event within a short window
  // after a programmatic change as programmatic — otherwise a leaked event captures the
  // PR view as the user's baseline, and the baseline restore on scroll re-shows the PR
  // zoom (the Bug 2 "zoom remains the same on scroll" regression).
  const lastProgrammaticChangeTsRef = useRef(0);
  const PROGRAMMATIC_EVENT_WINDOW_MS = 400;
  const isProgrammaticViewportChange = () =>
    programmaticViewportChangeRef.current ||
    (Date.now() - lastProgrammaticChangeTsRef.current) < PROGRAMMATIC_EVENT_WINDOW_MS;

  // Run a programmatic VOI/camera change with the guard raised. The boolean guard covers
  // synchronous events; the timestamp (stamped before AND after the awaited change)
  // covers Cornerstone's async post-render events via isProgrammaticViewportChange().
  const runProgrammaticViewportChange = async (fn) => {
    programmaticViewportChangeRef.current = true;
    lastProgrammaticChangeTsRef.current = Date.now();
    try {
      return await fn();
    } finally {
      lastProgrammaticChangeTsRef.current = Date.now();
      setTimeout(() => { programmaticViewportChangeRef.current = false; }, 0);
    }
  };

  // ── User "baseline" view (Bug 2) ─────────────────────────────────────────────
  // The zoom / pan / rotation / flip / windowing the USER wants on frames a PR does
  // NOT reference. PR viewport-state is scoped to its own frame: on the PR frame we
  // show the PR view, on every other frame we restore this baseline so the PR's
  // zoom/pan/window never bleeds across the stack. It is seeded when a PR is selected
  // (the pre-PR view) and updated on every manual adjustment, so it always tracks the
  // user's own last view. getViewPresentation() captures zoom/pan RELATIVE to fit
  // (slice-independent), so restoring it can never shift the image plane on a
  // scout-style series where each frame has a different position.
  const userBaselineRef = useRef(null);

  const captureUserBaseline = async () => {
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    try {
      const viewPres = vp.getViewPresentation?.();
      const voiRange = vp.getProperties?.()?.voiRange;
      userBaselineRef.current = {
        viewPres: viewPres ? { ...viewPres } : null,
        voiRange: voiRange ? { ...voiRange } : null,
      };
    } catch (_) {}
  };

  const restoreUserBaseline = async () => {
    const b = userBaselineRef.current;
    if (!b) return;
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    try {
      if (b.voiRange) vp.setProperties({ voiRange: b.voiRange });
      if (b.viewPres) vp.setViewPresentation(b.viewPres);
      vp.render();
    } catch (_) {}
  };

  const [hpSeriesDataLoaded, setHPSeriesDataLoaded] = useState(false);
  const {
    activeViewportIndex,
    changeActiveViewportIndex,
    viewportSeriesData,
    changeViewportSeriesDataUpdated,
    viewportRow,
    viewportColumn,
    addViewportElement,
    viewportElements,
    activeTool,
    mouseButtonToolAssignments,
    previousActiveTool,
    showOverlay,
    setActiveTool,
    setPreviousActiveTool,
    setViewportRow,
    setViewportColumn,
    contextMenuOpen,
    setContextMenuOpen,
    originalImageActiveState,
    editWarning,
    setEditWarning,
    isCineEnabled,
    setIsCineEnabled,
    isSynchronizedEnabled,
    setIsSynchronizedEnabled,
    syncMode,
    isMPRActive,
    dragEvent,
    setDragEvent,
    activeViewportModality,
    setActiveViewportModality,
    isCompareActive,
    showCompare,
    setShowCompare,
    isReferenceLinesEnabled,
    setIsReferenceLinesEnabled,
    disableAddPathology,
    setDisableAddPathology,
    setAllowAddingTextAnnotation,
    setOriginalImageActiveState,
    isReferenceLineActivated,
    setIsReferenceLineActivated,
    setImageLoadedOnViewport,
    updateBBPosition,
    setViewportLoadingComplete,
    handleDefaultToolChange,
    isScrollingUp,
    setIsScrollingUp,
    viewportHpLayout,
    viewportHpImage,
    viewportOldState,
    setViewportOldState,
    updateViewportProperties,
    viewportStates,
    viewportDoubleClickIndex, setViewportDoubleClickIndex,
    viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst,
    handleRemoveWarning,
    boundingBoxAdding, setBoundingBoxAdding,
    isSrSelected, setIsSrSelected, 
    isCropEnable, maskingConfirm, setMaskingConfirm,
    disableMasking,
    isAutoLoadLayout, setIsAutoLoadLayout,
    linkedViewports, setLinkedViewports,
    isSpineLabellingActive,
    spineLabels,
    markViewportImageLoaded,
  } = useContext(ViewportContext);

  // Publish this viewport's real load state; the cleanup covers the layout
  // unmounting the slot (2x2 -> 1x1 -> 2x2), which drops the image while
  // viewportSeriesData still holds the old series.
  useEffect(() => {
    markViewportImageLoaded(viewportIndex, viewportLoaded);
    return () => markViewportImageLoaded(viewportIndex, false);
  }, [viewportIndex, viewportLoaded, markViewportImageLoaded]);

  const {
    activeThumbnailIndex,
    changeActiveThumbnailIndex,
    activeThumbnailData,
    lateralThumbnailIndex,
    activeModality,
    setActiveModality,
    setActiveStudyId,
    thumbnailLoadingComplete,
    setLateralThumbnailIndex,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);

  const { setAlertSuccessModal, 
    alertSuccessModal, 
    setForReinferenceInProgress,
    reportDoneStatusState,
    usgAgentEnabled, reportingDoctorName, isWordFilePath ,
    studyDescription,
    refreshScDicomLibrary,
    markPendingCapture,
    activeTabKey,
  } = useContext(studyReportContext);

  const {isAgenticTab} = useContext(AgenticReportingContext);
  const {enableLlmReport} = useContext(userContext);
  const { theme } = useContext(themeContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [srReport, setSRReport] = useState("");
  const [imageCount, setImageCount] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewportData, setViewportData] = useState(activeThumbnailData);
  const [thumbnailId, setThumbnailId] = useState();
  const [voi, setVOI] = useState({ windowCenter: null, windowWidth: null });
  const [scale, setScale] = useState(1);
  const [initialVOIRange, setInitialVOIRange] = useState({});
  const [markers, setMarkers] = useState({});
  const elementRef = useRef(null);
  const impressionRef = useRef(null);
  const draggableRef = useRef(null);
  const [scrollbarHeight, setScrollbarHeight] = useState("100px");
  const [isActivated, setIsActivated] = useState(false);
  const [viewportLevelCINEEnabled, setViewportLevelCINEEnabled] =
    useState(true);
  const [viewportRendered, setViewportRendered] = useState(false);
  const { showToastv2 } = useContext(toastContext);
  const [viewportLoaderRunning, setViewportLoaderRunning] = useState(true);
  const [showForceReinference, setShowForceReinference] = useState(false);
  const [nonFrontalImageId, setNonFrontalImageId] = useState(null);
  const [viewportFocusCalled, setViewportFocusCalled] = useState(false);
  const {roles, username, userId} = useContext(userContext);

  const setScrollLoaderForIndex = useCallback((targetIndex, imageIdsOverride = null, forcePending = false) => {
    const seriesImageIds = imageIdsOverride || viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      clearScrollImageLoader();
      return;
    }

    const safeTargetIndex = Math.max(0, Math.min(targetIndex, seriesImageIds.length - 1));
    const imageId = seriesImageIds[safeTargetIndex];

    if (!imageId) {
      clearScrollImageLoader();
      return;
    }

    if (!forcePending && !!cache.getImage(imageId)) {
      clearScrollImageLoader();
      return;
    }

    pendingScrollImageRef.current = {
      viewportIndex,
      targetIndex: safeTargetIndex,
      imageId,
    };

    if (scrollLoaderDelayTimerRef.current) {
      clearTimeout(scrollLoaderDelayTimerRef.current);
    }

    scrollLoaderDelayTimerRef.current = setTimeout(() => {
      // Re-check cache at trigger time because image may have loaded during
      // debounce window; in that case avoid showing a stale loader.
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
        scrollLoaderDelayTimerRef.current = null;
        return;
      }

      setScrollImageLoadState((prev) => {
        if (prev.loading && prev.imageId === imageId) {
          return prev;
        }
        return {
          loading: true,
          targetIndex: safeTargetIndex,
          imageId,
        };
      });
      scrollLoaderDelayTimerRef.current = null;
    }, 80);
  }, [clearScrollImageLoader, viewportIndex, viewportSeriesData]);

  const [clippedStudyImages, setClippedStudyImages] = useState([]);
  const [viewportRotation, setViewportRotation] = useState(0);
  const viewportRef = useRef(null);
  const rightClickTimer = useRef(null);
  const isDragging = useRef(false);
  const rightClickThreshold = 400; 

  const updateKeyImageStar = async () => {
    const viewport = await getViewport(viewportIndex);
    if (
      viewport &&
      viewport.imageIds.length != 0 &&
      (isKeyImageAlreadyPresent(viewport, keyImages) ||
        isKeyImageAlreadyPresent(viewport, keyObjectImages) ||
        (priors && (isKeyImageAlreadyPresent(viewport, priorStudyKeyImages) ||
          isKeyImageAlreadyPresent(viewport, priorStudyKeyObjectImages))))
    ) {
      setShowKeyImageStar(true);
    } else {
      setShowKeyImageStar(false);
    }
  };

  const updateNonFrontalButton = async () => {
    const viewport = await getViewport(viewportIndex);

    if (viewport && viewport.imageIds.length != 0) {
      if (
        isNonFrontalImagePresent(
          viewport,
          nonFrontalImages,
          setNonFrontalImageId
        )
      ) {
        setShowForceReinference(true);
      } else {
        setShowForceReinference(false);
      }
    }
  };

  // updateNonFrontalButton is otherwise only invoked from the STACK_NEW_IMAGE
  // handler below. nonFrontalImages loads asynchronously from the study API
  // and often arrives after that event has already fired for the initially
  // displayed image — without this effect, a chest study whose default view
  // is the flagged non-frontal image never gets its button state recomputed
  // until the user manually navigates the stack.
  useEffect(() => {
    if (viewportLoaded) {
      updateNonFrontalButton();
    }
  }, [nonFrontalImages, viewportLoaded]);

  const signalSyncTargetLoaders = useCallback((sourceIndex) => {
    if (!isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    const sourceImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    const sourceLength = sourceImageIds.length;

    if (sourceLength <= 1) {
      return;
    }

    const sourceStudy = viewportSeriesData?.[viewportIndex]?.study;
    let targetViewportIndices = viewportSeriesData
      .map((data, idx) => ({ data, idx }))
      .filter(({ data, idx }) => idx !== viewportIndex && data?.stack && data.stack !== "")
      .map(({ idx }) => idx);

    if (syncMode === SYNC_MODES.AUTOMATIC && sourceStudy) {
      targetViewportIndices = targetViewportIndices.filter(
        (idx) => viewportSeriesData?.[idx]?.study === sourceStudy
      );
    }

    if (linkedViewports.length > 0) {
      targetViewportIndices = targetViewportIndices.filter((idx) => linkedViewports.includes(idx));
    }

    targetViewportIndices.forEach((targetViewportIdx) => {
      const targetImageIds = viewportSeriesData?.[targetViewportIdx]?.stack?.thumbnailImageIds || [];

      if (targetImageIds.length <= 1) {
        eventTarget.dispatchEvent(
          new CustomEvent(SYNC_TARGET_IMAGE_LOADING_EVENT, {
            detail: {
              viewportIndex: targetViewportIdx,
              loading: false,
            },
          })
        );
        return;
      }

      const mappedIndex = Math.round((sourceIndex / (sourceLength - 1)) * (targetImageIds.length - 1));
      const safeTargetIndex = Math.max(0, Math.min(mappedIndex, targetImageIds.length - 1));

      // If the target index hasn't changed since the last signal, the target
      // viewport is already at that frame (e.g. source scrolled past boundary
      // and the index keeps clamping to min/max).  No navigation will happen
      // so there is nothing to show a loader for.
      if (lastSignaledTargetIndexRef.current[targetViewportIdx] === safeTargetIndex) {
        return;
      }
      lastSignaledTargetIndexRef.current[targetViewportIdx] = safeTargetIndex;

      const targetImageId = targetImageIds[safeTargetIndex];

      eventTarget.dispatchEvent(
        new CustomEvent(SYNC_TARGET_IMAGE_LOADING_EVENT, {
          detail: {
            viewportIndex: targetViewportIdx,
            targetIndex: safeTargetIndex,
            imageId: targetImageId,
            loading: !!targetImageId,
          },
        })
      );

      // Priority-download the target image into cache without navigating
      // the viewport.  This avoids triggering STACK_VIEWPORT_SCROLL on the
      // target, which would cause the Cornerstone bidirectional synchronizer
      // to echo back and hang the source scrollbar.
      // The existing IMAGE_LOADED handler on the target viewport will
      // navigate and clear the loader once the image is ready.
      if (targetImageId && !cache.getImage(targetImageId)) {
        imageLoader.loadAndCacheImage(targetImageId).catch(() => {});
      }
    });
  }, [
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportIndex,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (viewportLoaded) {
      updateKeyImageStar();
    }
  }, [keyImages, keyObjectImages, viewportLoaded]);

  const updateForceReinferenceImageIds = (nonFrontalImages) => {
    const foundObject = nonFrontalImages.find(obj => obj.imageId === nonFrontalImageId);
      if (foundObject) {
        const imageUrl = foundObject.imageUrl;
        setForceReinferenceImageIds(prevState => [...prevState, imageUrl]);
      }
  }

  const forceReinference = async () => {
    const response = await forceReinferenceImage(
      studyParentId,
      nonFrontalImageId
    );
    if (response.status === 200) {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = true;
        newItem.isWarning = false;
        newItem.description = t("viewer.tools.force-reinference-success");
        return newItem;
      });
    } else {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = false;
        newItem.description = response.data.message;
        return newItem;
      });
    }
  };

  useEffect(() => {
    if (viewportIndex !== 0) return;
    if (
      activeViewportIndex / VIEWPORT_COLUMN >= viewportRow ||
      activeViewportIndex % VIEWPORT_COLUMN >= viewportColumn
    ) {
      setActive();
    }
  }, [viewportColumn, viewportRow]);

  useEffect(() => {
    const getOrientationMarkers = async (event) => {
      const m = await updateOrientationMarkers(
        event,
        "viewport_" + viewportIndex
      );
      setMarkers(m);
      // updateKeyImageStar();
      updateNonFrontalButton();

      const viewport = await getViewport(viewportIndex);
      const currentImageIndex = viewport.getCurrentImageIdIndex();

      // Mixed-series two-axis: during cine the viewport's imageIdIndex is
      // the FRAME of the active instance; the scrollbar should keep
      // showing the OUTER (per-instance) position. getCurrentOuterIndex
      // returns the pinned outer idx for mixed-series viewports and null
      // otherwise (in which case we fall back to the viewport's own idx).
      // For single-instance multiframe viewports (engine exists, no outer
      // index), skip setCurrentImage entirely — the scrollbar max is 0 so
      // the only valid position is 0, and updating currentImage to the
      // current frame index would break callers that index into stack.images.
      const outerIdx = getCurrentOuterIndex("viewport_" + viewportIndex);
      if (outerIdx != null) {
        setCurrentImage(outerIdx);
      } else if (!getEngine("viewport_" + viewportIndex)) {
        setCurrentImage(viewport.getCurrentImageIdIndex());
      }
      // Trigger PR check on every new image display — including series switch
      // where currentImage stays 0 and the normal state-change bail-out skips it.
      setPrCheckCount((c) => c + 1);

      const imageIds = viewport?.getImageIds?.() || [];
      const currentImageId = imageIds[currentImageIndex];

      // If current image is already available, loader should not remain active.
      if (currentImageId && cache.getImage(currentImageId)) {
        clearScrollImageLoader();
      }

      if (
        pendingScrollImageRef.current?.viewportIndex === viewportIndex &&
        pendingScrollImageRef.current?.targetIndex === currentImageIndex
      ) {
        clearScrollImageLoader();
      }

      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex !== null &&
        isReferenceLineActivated
      ) {
        setIsReferenceLinesEnabled(true);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_NEW_IMAGE,
        getOrientationMarkers
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_NEW_IMAGE,
          getOrientationMarkers
        );
      };
    }
  }, [viewportElement, nonFrontalImages, clearScrollImageLoader]);

  useEffect(() => {
    const onWheelStart = async (event) => {
      const deltaY = event?.deltaY;
      if (typeof deltaY !== "number" || deltaY === 0) {
        return;
      }

      lastUserScrollSourceRef.current = {
        viewportIndex,
        timestamp: Date.now(),
      };

      const viewport = await getViewport(viewportIndex);
      if (!viewport) {
        return;
      }

      const viewportImageIds = viewport?.getImageIds?.() || [];
      const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
      const imageIds = viewportImageIds.length > 0 ? viewportImageIds : seriesImageIds;

      if (!Array.isArray(imageIds) || imageIds.length === 0) {
        return;
      }

      const currentIndex = viewport.getCurrentImageIdIndex();
      if (typeof currentIndex !== "number") {
        return;
      }

      const direction = deltaY > 0 ? 1 : -1;
      const nextIndex = Math.max(0, Math.min(currentIndex + direction, imageIds.length - 1));
      const imageId = imageIds[nextIndex];
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
      } else {
        setScrollLoaderForIndex(nextIndex, imageIds);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener("wheel", onWheelStart, { passive: true });

      return () => {
        viewportElement?.removeEventListener("wheel", onWheelStart);
      };
    }
  }, [
    viewportElement,
    viewportIndex,
    viewportSeriesData,
    setScrollLoaderForIndex,
  ]);

  useEffect(() => {
    const updateImageIndex = async () => {
      const viewport = await getViewport(viewportIndex);
      const currentIndex = viewport.getCurrentImageIdIndex();

      // See getOrientationMarkers above — same reason: during cine the
      // scrollbar must reflect outer instance position, not the frame
      // index of the active multi-frame instance. For single-instance
      // multiframe, skip entirely (engine exists, no outer index).
      const outerIdx = getCurrentOuterIndex("viewport_" + viewportIndex);
      if (outerIdx != null) {
        setCurrentImage(outerIdx);
      } else if (!getEngine("viewport_" + viewportIndex)) {
        setCurrentImage(viewport.getCurrentImageIdIndex());
      }

      const recentlyUserScrolledThisViewport =
        lastUserScrollSourceRef.current?.viewportIndex === viewportIndex &&
        Date.now() - (lastUserScrollSourceRef.current?.timestamp || 0) < 450;

      if (
        isSynchronizedEnabled &&
        syncMode !== SYNC_MODES.DISABLED &&
        (viewportIndex === activeViewportIndex || recentlyUserScrolledThisViewport)
      ) {
        signalSyncTargetLoaders(currentIndex);
      }

      const viewportImageIds = viewport?.getImageIds?.() || [];
      const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
      const imageIds = viewportImageIds.length > 0 ? viewportImageIds : seriesImageIds;
      const imageId = imageIds[currentIndex];
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
      } else {
        setScrollLoaderForIndex(currentIndex, imageIds);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_VIEWPORT_SCROLL,
        updateImageIndex
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_VIEWPORT_SCROLL,
          updateImageIndex
        );
      };
    }
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    setScrollLoaderForIndex,
    signalSyncTargetLoaders,
    syncMode,
    viewportElement,
    viewportIndex,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (!viewportLoaded) {
      return;
    }

    if (typeof currentImage !== "number") {
      return;
    }

    const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      return;
    }

    setScrollLoaderForIndex(currentImage, seriesImageIds);
  }, [
    currentImage,
    viewportLoaded,
    viewportIndex,
    viewportSeriesData,
    setScrollLoaderForIndex,
  ]);

  useEffect(() => {
    if (!scrollImageLoadState.loading || !scrollImageLoadState.imageId) {
      return;
    }

    const onImageLoaded = async (event) => {
      const loadedImageId = event?.detail?.image?.imageId;
      const pending = pendingScrollImageRef.current;
      if (!pending || loadedImageId !== pending.imageId) {
        return;
      }

      // Navigate only if Cornerstone's synchronizer hasn't already put us
      // at the correct frame.  During partial downloads the synchronizer
      // cannot map to the target slice (no metadata yet), so we must
      // navigate manually.  During fast scrolling only the LAST pending
      // image matches here, so at most one updateViewport fires — this
      // avoids the rapid-fire echo-back that previously caused scroll hang.
      try {
        const viewport = await getViewport(viewportIndex);
        const currentIndex = viewport?.getCurrentImageIdIndex?.();
        if (
          typeof pending.targetIndex === "number" &&
          typeof currentIndex === "number" &&
          currentIndex !== pending.targetIndex
        ) {
          await updateViewport(viewportIndex, pending.targetIndex);
        }
      } catch (e) {
        // Viewport may have been destroyed between event and handler
      }

      clearScrollImageLoader();
    };

    eventTarget.addEventListener(Enums.Events.IMAGE_LOADED, onImageLoaded);
    return () => {
      eventTarget.removeEventListener(Enums.Events.IMAGE_LOADED, onImageLoaded);
    };
  }, [scrollImageLoadState.loading, scrollImageLoadState.imageId, clearScrollImageLoader, viewportIndex]);

  useEffect(() => {
    const onSyncTargetImageLoading = (event) => {
      const detail = event?.detail || {};

      if (detail.viewportIndex !== viewportIndex) {
        return;
      }

      if (!detail.loading) {
        clearScrollImageLoader();
        return;
      }

      // If the image is already in Cornerstone's cache, just clear the loader.
      // Do NOT navigate the viewport — Cornerstone's synchronizer handles that.
      // Navigating here would trigger STACK_VIEWPORT_SCROLL echo-back through
      // the bidirectional synchronizer and hang the source's mouse scroll.
      if (detail.imageId && cache.getImage(detail.imageId)) {
        clearScrollImageLoader();
        return;
      }

      pendingScrollImageRef.current = {
        viewportIndex,
        targetIndex: detail.targetIndex,
        imageId: detail.imageId,
      };

      // Cancel any lingering debounce timer from a previous scroll event.
      if (scrollLoaderDelayTimerRef.current) {
        clearTimeout(scrollLoaderDelayTimerRef.current);
        scrollLoaderDelayTimerRef.current = null;
      }

      // Show the loader immediately for sync targets so the brief blank frame
      // that Cornerstone renders while loading an uncached image is hidden by
      // the overlay rather than visible to the user (prevents flickering).
      setScrollImageLoadState((prev) => {
        if (prev.loading && prev.imageId === detail.imageId) {
          return prev;
        }
        return {
          loading: true,
          targetIndex: detail.targetIndex,
          imageId: detail.imageId,
        };
      });
    };

    eventTarget.addEventListener(SYNC_TARGET_IMAGE_LOADING_EVENT, onSyncTargetImageLoading);
    return () => {
      eventTarget.removeEventListener(SYNC_TARGET_IMAGE_LOADING_EVENT, onSyncTargetImageLoading);
    };
  }, [viewportIndex, clearScrollImageLoader]);

  useEffect(() => {
    return () => {
      if (scrollLoaderDelayTimerRef.current) {
        clearTimeout(scrollLoaderDelayTimerRef.current);
      }
    };
  }, []);


   
  const loadAIOutlineAndHeatmap = async (overlayStacks = null) => {
    const viewportSeries = viewportSeriesData?.[viewportIndex];
    const fallbackThumbnailIndex =
      viewportSeries?.thumbnailIndex ?? activeThumbnailIndex;
    // Prefer the modality passed explicitly via overlayStacks. handleDrop calls this
    // synchronously (through loadSeriesIntoViewport) right after kicking off the
    // viewportSeriesData/activeModality state updates for the JUST-dropped series -
    // those updates haven't committed yet, so viewportSeries?.modality/activeModality
    // here would still read the PREVIOUS series' modality (e.g. a prior CT) instead
    // of the new one, wrongly gating the overlay off for a valid X-ray drop.
    const normalizedActiveModality = (
      overlayStacks?.modality || viewportSeries?.modality || activeModality || ""
    )
      .toString()
      .trim()
      .toUpperCase();
    const explicitHeatmapIds = overlayStacks?.heatmapStack?.imageIds;
    const explicitOutlineIds = overlayStacks?.outlineStack?.imageIds;
    const viewportHeatmapIds =
      explicitHeatmapIds ||
      viewportSeries?.heatmapStack?.imageIds ||
      studyData?.heatmapStacks?.[fallbackThumbnailIndex]?.imageIds;
    const viewportOutlineIds =
      explicitOutlineIds ||
      viewportSeries?.outlineStack?.imageIds ||
      studyData?.outlineStacks?.[fallbackThumbnailIndex]?.imageIds;

    if (!SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(normalizedActiveModality)) {
      return;
    }

    // await resizeViewport();
    await rerenderViewport();
    loadHeatMap(
      viewportHeatmapIds,
      isHeatMapEnabled,
      viewportIndex
    );
    // await resizeViewport();
    await rerenderViewport();
    loadOutline(
      viewportOutlineIds,
      isOutlineEnabled,
      viewportIndex
    );
  };

  useEffect(() => {
    const enableReferenceLine = async (event) => {
      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex != null &&
        isReferenceLineActivated
      ) {
        setTimeout(() => {
          setIsReferenceLinesEnabled(true);
        }, 1000);
      }
    };

    if (
      viewportElement !== null &&
      viewportIndex == 1 &&
      !isReferenceLinesEnabled
    ) {
      viewportElement?.addEventListener(
        Enums.Events.IMAGE_RENDERED,
        enableReferenceLine
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.IMAGE_RENDERED,
          enableReferenceLine
        );
      };
    }
  }, [viewportElement]);




  // useEffect(() => {
  //   const stopLoader = async (event) => {
  //     console.log("IMAGE RENDERED");
  //     console.log(event);
  //     if (event.detail.viewportStatus === "rendered") {
  //       setViewportLoaderRunning(false);
  //     }
  //   };

  //   if (viewportElement !== null) {
  //     viewportElement?.addEventListener(
  //       Enums.Events.IMAGE_RENDERED,
  //       stopLoader
  //     );

  //     return () => {
  //       viewportElement?.removeEventListener(
  //         Enums.Events.IMAGE_RENDERED,
  //         stopLoader
  //       );
  //     };
  //   }
  // }, [viewportElement]);

  useEffect(() => {
    loadAIOutlineAndHeatmap();
  }, [currentImage, isHeatMapEnabled, isOutlineEnabled]);

  // Note: the series scrollbar position is driven entirely by `currentImage`,
  // which the STACK_NEW_IMAGE handlers keep pinned to the OUTER (per-instance)
  // index during cine (getCurrentOuterIndex) and leave untouched for
  // single-instance multiframe. No separate "freeze while playing" subscription
  // is needed — the old one captured a stale currentImage and snapped the
  // scrollbar to the top during playback.

  // Reactive PR apply: when a frame becomes active its metadata is now loaded,
  // so we can match it against any cached PR that references it by SOP UID.
  useEffect(() => {
    if (!viewportLoaded) return;
    const applyPRForCurrentFrame = async () => {
      const vp = await getViewport(viewportIndex);
      if (!vp) return;
      const imageId = vp.getCurrentImageId();
      if (!imageId) return;

      // Only match by exact SOP UID from metadata — URL substring matching
      // causes false positives because one DICOM UID is a prefix of another.
      const meta = cornerstoneMetaData.get("sopCommonModule", imageId);
      const sopUID = (meta?.sopInstanceUID ?? meta?.SOPInstanceUID)?.trim();

      // Always update the current-slice SOP UID so the PR list panel filters correctly.
      setCurrentSopUID(sopUID || null);

      if (!sopUID) return;

      const allPREntries = getAllCachedPREntries();
      const currentStack = viewportSeriesData[viewportIndex]?.stack;

      // Auto-open is OFF (bug 8): only apply PRs the user has EXPLICITLY selected
      // in the list panel. A PR not yet in prItems, or with selected !== true, is
      // treated as not selected — so nothing is auto-applied on study open.
      const selectedUrls = new Set(
        prItemsRef.current.filter((i) => i.selected === true).map((i) => i.url)
      );

      // Find the first SELECTED PR that references the current frame.
      let matchedPR = null;
      let matchedPRUrl = null;
      for (const { url, data } of allPREntries) {
        if (!selectedUrls.has(url)) continue;
        if (data.referencedSOPInstanceUIDs?.some((u) => u?.trim() === sopUID)) {
          matchedPR = data;
          matchedPRUrl = url;
          break;
        }
      }

      // PR viewport-state is scoped to its OWN frame: show the PR view only on the
      // frame the PR references, and the user's baseline view on every other frame.
      const prModeActive = selectedUrls.size > 0;

      if (matchedPR) {
        // Ensure a baseline exists (the user's pre-PR view) BEFORE we override the
        // viewport with the PR view — otherwise scrolling off this frame would have
        // nothing to restore and the PR zoom would persist across the stack (Bug 2).
        // Safe: at this instant the viewport still shows the user's own view (the PR
        // view is applied on the lines below), not the PR's.
        if (!userBaselineRef.current) await captureUserBaseline();

        // On a PR-referenced frame: place annotations if not yet placed, and (re)apply
        // the PR's viewport state every time we ENTER the frame so the PR view is
        // always shown on its own frame — regardless of the user's baseline. Guard the
        // programmatic writes so their VOI/CAMERA events aren't misread as user input.
        const alreadyAnnotated = getPRAnnotatedImageIds().has(imageId);
        if (!alreadyAnnotated) {
          await runProgrammaticViewportChange(() =>
            applyPRToViewport(matchedPR, viewportIndex, currentStack, { scroll: false, prUrl: matchedPRUrl })
          );
          setPrAppliedCount((c) => c + 1);
          setStudyPRAppliedCount((c) => c + 1);
        } else {
          await runProgrammaticViewportChange(() =>
            reapplyPRViewportState(matchedPR, viewportIndex)
          );
        }
      } else if (prModeActive) {
        // Non-PR frame while a PR is selected: restore the user's baseline zoom/pan/
        // window here so the PR's view does NOT bleed across the stack (Bug 2).
        await runProgrammaticViewportChange(() => restoreUserBaseline());
      }
      // If no PR is selected at all, leave the viewport untouched (normal scroll).
    };
    applyPRForCurrentFrame();
  }, [currentImage, viewportLoaded, prCheckCount]);

  // ── Keep the PR list panel in sync with the study structure ──────────────────
  // The PR list (prItems) is also built inside loadViewport, but that only runs
  // on (re)load. When a PR is saved and merged into studyData in place
  // (waitForSeriesReadyAndMerge), studyData gains a new PR series but the popup
  // stayed empty until a manual page reload. This effect rebuilds prItems whenever
  // the set of PR series changes, so a freshly-saved PR appears in the popup without
  // a reload. Existing selections are preserved by URL.
  const prStackUrlKey = (studyData?.stacks ?? [])
    .filter((s) => s.modality === "PR")
    .map((s) => s.thumbnailImageIds?.[0])
    .filter(Boolean)
    .join("|");
  useEffect(() => {
    const prUrls = (studyData?.stacks ?? [])
      .filter((s) => s.modality === "PR")
      .map((s) => s.thumbnailImageIds?.[0])
      .filter(Boolean);
    if (!prUrls.length) return;
    let cancelled = false;
    (async () => {
      const items = [];
      for (const prUrl of prUrls) {
        try {
          const prData = await parsePRFile(prUrl); // cached after first parse
          items.push({
            url:         prUrl,
            description: prData.contentDescription || prData.contentLabel || "",
            creatorName: prData.contentCreatorName || "",
            date:        prData.presentationCreationDate || "",
            selected:    false,
          });
        } catch (err) {
          console.warn("Failed to parse PR (list sync):", err);
        }
      }
      if (cancelled) return;
      // Merge: keep any existing selection state, keyed by URL.
      const prevByUrl = new Map(prItemsRef.current.map((i) => [i.url, i]));
      setPrItems(items.map((it) => {
        const prev = prevByUrl.get(it.url);
        return prev ? { ...it, selected: prev.selected } : it;
      }));
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prStackUrlKey]);

  // ── PR list panel toggle handlers ────────────────────────────────────────────

  /**
   * Helper: after removing a PR, reset the viewport to its pre-PR state then
   * re-apply viewport state (VOI LUT + camera) from any still-selected PRs on
   * this slice.  Annotations for the still-selected PRs are already in the
   * manager — only the viewport state needs refreshing.
   */
  const _resetAndRestoreViewportState = async (nextItems) => {
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    // Reset viewport to original (no-PR) state.
    vp.resetCamera({ resetPan: true, resetZoom: true, resetToCenter: true });
    vp.resetProperties();
    // Re-apply viewport state from PRs that are still selected on this slice.
    if (currentSopUID) {
      const stillSelected = nextItems.filter((i) => i.selected);
      for (const rem of stillSelected) {
        const pd = getCachedPRData(rem.url);
        if (!pd) continue;
        const refersHere = pd.referencedSOPInstanceUIDs?.some((u) => u.trim() === currentSopUID);
        if (refersHere) await reapplyPRViewportState(pd, viewportIndex);
      }
    }
    vp.render();
  };

  const handlePRToggle = async (url) => {
    const item = prItems.find((i) => i.url === url);
    if (!item) return;

    if (item.selected) {
      // Deselect: remove this PR's annotations, reset viewport, restore remaining.
      removePRAnnotationsByUrl(url, null);
      const nextItems = prItems.map((i) => i.url === url ? { ...i, selected: false } : i);
      setPrItems(nextItems);
      await runProgrammaticViewportChange(() => _resetAndRestoreViewportState(nextItems));
    } else {
      // Selecting a PR: remember the user's current view as the baseline for non-PR
      // frames (Bug 2), then apply the PR fully (annotations + viewport state). The
      // PR view is shown on its own frame; other frames restore this baseline.
      await captureUserBaseline();
      const prData = getCachedPRData(url);
      if (prData) {
        const currentStack = viewportSeriesData[viewportIndex]?.stack;
        await runProgrammaticViewportChange(() =>
          applyPRToViewport(prData, viewportIndex, currentStack, { scroll: false, prUrl: url })
        );
      }
      setPrItems((prev) => prev.map((i) => i.url === url ? { ...i, selected: true } : i));
    }
  };

  // sliceItems = the already-filtered list of PRs for the current slice.
  const handlePRToggleAll = async (selectAll, sliceItems) => {
    const itemsToProcess = sliceItems ?? prItems;
    const urlsToProcess  = new Set(itemsToProcess.map((i) => i.url));

    if (selectAll) {
      // Remember the user's current view as the baseline for non-PR frames (Bug 2)
      // before applying, then re-apply all deselected PRs in this slice.
      await captureUserBaseline();
      const currentStack = viewportSeriesData[viewportIndex]?.stack;
      for (const item of itemsToProcess) {
        if (!item.selected) {
          const prData = getCachedPRData(item.url);
          if (prData) {
            await runProgrammaticViewportChange(() =>
              applyPRToViewport(prData, viewportIndex, currentStack, { scroll: false, prUrl: item.url })
            );
          }
        }
      }
      setPrItems((prev) => prev.map((i) => urlsToProcess.has(i.url) ? { ...i, selected: true } : i));
    } else {
      // Deselect all: remove annotations, reset viewport (nothing to restore after).
      for (const item of itemsToProcess) {
        if (item.selected) removePRAnnotationsByUrl(item.url, null);
      }
      const nextItems = prItems.map((i) => urlsToProcess.has(i.url) ? { ...i, selected: false } : i);
      setPrItems(nextItems);
      // All cleared — reset to original viewport state with no re-apply.
      await runProgrammaticViewportChange(() => _resetAndRestoreViewportState(nextItems));
    }
  };

  // useEffect(() => {
  //   if (viewportLoading.viewport1Loading) {
  //     updateBBPosition(studyBoundingBox);
  //   }
  // }, [activeViewportIndex, currentImage, viewportLoading]);

  const handleShowOriginalToggle = async () => {
    const currentStackModality = viewportSeriesData[activeViewportIndex]?.stack?.modality;
    if (activeViewportIndex === viewportIndex && currentStackModality !== "PR") {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await changeStack(
        activeViewportIndex,
        thumbnailId,
        viewportSeriesData[activeViewportIndex].stack,
        viewportSeriesData[activeViewportIndex].originalStack,
        originalImageActiveState[viewportIndex],
        currentImage,
        setLoaderRunning,
        ref
      );
      setTimeout(() => {
        ref.current.complete();
      }, 500);
      if (originalImageActiveState[viewportIndex]) {
        logViewOriginalImage(studyParentId);
      }
    }
  };

  useEffect(() => {
    if (viewportRendered) {
      handleShowOriginalToggle();
    }
  }, [originalImageActiveState]);

  const enableViewportElement = async () => {
    setViewportLoaderRunning(false);
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    addViewportElement(element);
    setViewportElement(element);
    activateViewport(element, viewportIndex);
    setViewportModality(activeModality);
    setActiveViewportModality(activeModality);
    setIsActivated(true);
    // if (viewportIndex !== 0) {
    //   setViewportLoaderRunning(false);
    // }
  };

  useEffect(() => {
    enableViewportElement();
  }, []);

  const loadLateralSeriesInViewport = async () => {
    setViewportLoaderRunning(true);
    const toolGroup = await getToolGroupManager(
      getEnv("REACT_APP_TOOL_GROUP_ID")
    );
    toolGroup.addTool(cornerstonetools.ReferenceLinesTool.toolName);
    setIsReferenceLineActivated(true);
    setThumbnailId(lateralThumbnailIndex);
    setViewportLoaded(true);
    await loadViewport(lateralThumbnailIndex, viewportIndex);
    setIsReferenceLinesEnabled(true);
    await updateVoiForTheVeryFirstTimeForLateralSeries();
    setAllLoadingComplete(true);
  };

  const updateVoiForTheVeryFirstTimeForLateralSeries = async () => {
    const viewport = await getViewport(1);
    setVOI({
      windowCenter: Math.trunc(viewport.csImage.windowCenter),
      windowWidth: Math.trunc(viewport.csImage.windowWidth),
    });
  };

  useEffect(() => {
    if (
      lateralThumbnailIndex !== null &&
      lateralThumbnailIndex !== undefined &&
      viewportIndex === 1
    ) {
      loadLateralSeriesInViewport();
    }
  }, [lateralThumbnailIndex]);

  const getLateralSeriesIndex = async () => {
    // The priors viewer keeps the current study at priorStudyData[0] and hangs
    // every prior's series in the same thumbnail list. Only the current study's
    // series may fill the lateral viewport, so bound the search by its series
    // count — KO/PR excluded, since ThumbnailList skips them when numbering.
    const currentStudy =
      priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData;
    const seriesCount = (currentStudy?.stacks || []).filter(
      (stack) => stack.modality !== "KO" && stack.modality !== "PR"
    ).length;

    let index = await checkForLateralSeries(seriesCount);
    if (index !== -1) {
      setLateralThumbnailIndex(index);
    }
  };

  useEffect(() => {
    if (thumbnailLoadingComplete && !isMobile && (hpDataList == undefined || Object.keys(hpDataList).length === 0)) {
      getLateralSeriesIndex();
    }
  }, [thumbnailLoadingComplete]);

  useEffect(() => {
    if (viewportIndex === activeViewportIndex) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [isReferenceLinesEnabled]);

  useEffect(() => {
    // Only let one viewport instance handle the active-viewport change to
    // avoid multiple simultaneous toggleReferenceLines calls that race.
    if (isReferenceLinesEnabled && viewportIndex === activeViewportIndex) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [activeViewportIndex]);

  useEffect(() => {
    // Reference lines depend on the active (source) viewport sharing a
    // meaningful frame of reference with the others — see cornerstone's
    // ReferenceLinesTool enforceSameFrameOfReference check. CR/DX/US/SR/SC
    // images (e.g. a prior X-ray dropped into the active viewport) don't
    // carry one, so the lines it would project are meaningless. When the
    // active viewport's own content switches to one of these, turn the
    // cornerstone tool off — without touching isReferenceLinesEnabled (the
    // user's own toggle) — so loading a compatible series back into the
    // active viewport re-activates reference lines automatically.
    if (viewportIndex !== activeViewportIndex || !isReferenceLinesEnabled) {
      return;
    }
    if (REFLINES_SYNC_EXCLUDED_MODALITIES.includes(activeViewportModality)) {
      toggleReferenceLines(false, activeViewportIndex);
    } else {
      toggleReferenceLines(true, activeViewportIndex);
    }
  }, [activeViewportModality]);

  const updateInitialVOI = async () => {
    const viewport = await getViewport(viewportIndex);
    setVOI({
      windowCenter: viewport?.csImage?.windowCenter,
      windowWidth: viewport?.csImage?.windowWidth,
    });
  };

  const loadViewport = async (thumbnailIndex, viewportIndex) => {
    // Seed the thumbnail registry from the assigned series so
    // loadActiveViewport's getThumbnailViewport(thumbnailIndex) lookup never
    // misses for a series whose thumbnail hasn't lazily rendered yet (priors /
    // multiple studies). Idempotent — preserves an entry displayThumbnail
    // already created.
    registerThumbnailStack(
      thumbnailIndex,
      viewportSeriesData[viewportIndex]?.stack
    );
    setViewportLoaderRunning(true);
    setViewportLoading(() => {
      const newVal = { ...viewportLoading };
      if (viewportIndex == 0) {
        newVal.viewport1Loading = false;
      } else if (viewportIndex == 1) {
        newVal.viewport2Loading = false;
      } else if (viewportIndex == 2) {
        newVal.viewport3Loading = false;
      } else {
        newVal.viewport4Loading = false;
      }

      return newVal;
    });
    let maxImageCount;
    try {
      maxImageCount = await loadActiveViewport(
        thumbnailIndex,
        viewportIndex,
        setScale,
        setInitialVOIRange,
        setInitialVOI,
        isScrollingUp,
        setCurrentImage,
        currentImage,
        loadAIOutlineAndHeatmap,
        hpLoading ? viewportHpImage?.get(viewportIndex) : 0,
      );
    } catch (err) {
      // loadActiveViewport has no internal error handling and loadViewport is
      // not wrapped by its callers, so a rejection here used to skip every line
      // below — including setViewportLoaderRunning(false) — leaving the
      // full-viewport spinner stuck forever. This surfaced in the priors viewer,
      // which mounts several study viewports at once (current + priors): if any
      // one of them fails to load its series, that viewport spins the spinner
      // indefinitely. Clear the overlay and bail out of this viewport's load.
      console.error("[Viewport] loadActiveViewport failed — clearing loader:", err);
      setViewportLoaderRunning(false);
      return;
    }
    if(isScrollingUp){
      setIsScrollingUp(false);
    }
    if (viewportIndex === 0 || hpLoading) setImageLoadedOnViewport(true);
    setAllowAddingTextAnnotation(true);
    setViewportRendered(true);
    setTimeout(() => {
      setViewportLoading(() => {
        const newVal = { ...viewportLoading };
        if (viewportIndex == 0) {
          newVal.viewport1Loading = true;
        } else if (viewportIndex == 1) {
          newVal.viewport2Loading = true;
        } else if (viewportIndex == 2) {
          newVal.viewport3Loading = true;
        } else {
          newVal.viewport4Loading = true;
        }

        return newVal;
      });
    }, 1000);
    setImageCount(maxImageCount);
    if (
      !LATERAL_VIEW_MODALITY_LIST.includes(studyModality) ||
      isMobile ||
      sharedViewer
    ) {
      setLoaderRunning(false);

    }
    updateInitialVOI();
    setAllLoadingComplete(true);

    // Clear the full-viewport loading overlay as soon as the image is on
    // screen — BEFORE the best-effort PR/KO parsing below. Those loops await
    // parsePRFile/parseKOFile per stack; on the priors path (wadouri, multiple
    // studies) a slow or non-settling parse would otherwise keep the spinner
    // up forever even though the viewport already rendered. The final
    // setViewportLoaderRunning(false) at the end of this function is kept as a
    // harmless idempotent backstop.
    setViewportLoaderRunning(false);

    // Parse all Presentation State series so the PR list panel can offer them,
    // but do NOT auto-apply or auto-select — auto-open is OFF (bug 8).
    const prStacks = studyData.stacks?.filter((s) => s.modality === "PR") ?? [];
    const newPrItems = [];

    // Seed the user "baseline" view (Bug 2) from the natural view at load, so a PR
    // selected later restores to this baseline on non-PR frames until the user makes
    // their own adjustment. Best-effort — if the viewport isn't ready yet, the
    // baseline is (re)captured on the next manual change or when a PR is selected.
    if (prStacks.length > 0) {
      await captureUserBaseline();
    }

    // Preserve any PR the user had selected across a re-load (e.g. a layout change),
    // so changing the grid does NOT drop an applied PR (Bug 1). The reactive PR effect
    // re-applies the still-selected PRs to the current frame after this rebuild.
    const prevSelectedByUrl = new Map(
      prItemsRef.current.map((i) => [i.url, i.selected === true])
    );
    for (const prStack of prStacks) {
      try {
        const prUrl = prStack.thumbnailImageIds[0];
        if (prUrl) {
          // Parse + cache (populates the list panel). Application happens via the
          // reactive PR effect / handlePRToggle — not auto-opened on study open (bug 8).
          const prData = await parsePRFile(prUrl);
          newPrItems.push({
            url:         prUrl,
            description: prData.contentDescription || prData.contentLabel || "",
            creatorName: prData.contentCreatorName || "",
            date:        prData.presentationCreationDate || "",
            selected:    prevSelectedByUrl.get(prUrl) === true,
          });
        }
      } catch (err) {
        console.warn("Failed to parse PR:", err);
      }
    }
    if (newPrItems.length > 0) {
      setPrItems(newPrItems);
      // Nudge the reactive PR effect so preserved selections re-apply after a reload
      // (prItemsRef is synced before that effect re-runs).
      if (newPrItems.some((i) => i.selected)) setPrCheckCount((c) => c + 1);
    }

    // ── Auto-parse all Key Object stacks ──────────────────────────────────────
    // Each KO DICOM is a separate file; parsing them lets us show multiple KOs
    // per slice in the ViewportNavWidget star popup (the backend's per-image
    // keyImageTitle only stores one title even when several KOs reference the
    // same image).
    //
    // Look at every stack and accept anything that LOOKS like a KO — some
    // backends label the modality "KO", others "KEY OBJECT" or set only the
    // SOP Class UID.  Try every imageId on the stack as a URL, not just
    // thumbnailImageIds[0], since KO stacks often lack a thumbnail entry.
    const KO_SOP_CLASS = "1.2.840.10008.5.1.4.1.1.88.59";
    const allStacks = studyData.stacks ?? [];
    const koStacks = allStacks.filter((s) => {
      const mod = (s.modality || "").toUpperCase();
      return mod === "KO" || mod === "KEY OBJECT"
          || s.sopClassUid === KO_SOP_CLASS
          || s.sopClassUId === KO_SOP_CLASS;
    });

    for (const koStack of koStacks) {
      const candidateUrls = [
        ...(koStack.thumbnailImageIds ?? []),
        ...(koStack.imageIds ?? []),
      ].filter(Boolean);
      let parsedOk = false;
      for (const koUrl of candidateUrls) {
        try {
          const koData = await parseKOFile(koUrl);
          parsedOk = true;
          break;
        } catch (err) {
          console.warn("[KO] parse failed for", koUrl, err);
        }
      }
      if (!parsedOk) console.warn("[KO] no usable URL on stack", koStack);
    }
    setViewportLoaderRunning(false);
  };

  /**
   * Unified function for loading a series into a viewport.
   * Used by both drag-drop and thumbnail click flows.
   * @param {number} thumbnailIndex - Index of the thumbnail/series to load
   * @param {number} targetViewportIndex - Target viewport index
   * @param {object} [seriesStack] - Stack data (pass explicitly for drag-drop since viewportSeriesData may not be updated yet)
   */
  const loadSeriesIntoViewport = async (
    thumbnailIndex,
    targetViewportIndex,
    seriesStack = null,
    overlayStacks = null
  ) => {
    const stack = seriesStack || viewportSeriesData[targetViewportIndex]?.stack;

    // Clear any stale scroll-sync loader from a previous series before loading a new one.
    clearScrollImageLoader();
    setViewportLoaderRunning(true);
    setViewportProgressComplete(false);
    setViewportProgress(20);
    setViewportModality(activeModality);
    setActiveViewportModality(activeModality);

    // Handle SR modality
    if (activeModality === "SR") {
      generateSRReport(stack.thumbnailImageIds[0], setSRReport);
      setTimeout(() => {
        setViewportLoaderRunning(false);
        setIsSrSelected(true);
        if (targetViewportIndex === 0) setImageLoadedOnViewport(true);
      }, 1000);
      return;
    }

    setViewportLoaded(true);
    setThumbnailId(thumbnailIndex);
    await loadViewport(thumbnailIndex, targetViewportIndex);
    setViewportProgress(100);
    if (isHeatMapEnabled || isOutlineEnabled) {
      loadAIOutlineAndHeatmap(overlayStacks);
    }
    setViewportLoaderRunning(false);
    if (targetViewportIndex === 0) setViewportLoadingComplete(true);

    resetRotation(targetViewportIndex);
    resetStackPosition(targetViewportIndex);
  };

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  const handleLoadSecondTime = async () => {
    if (viewportSeriesData[viewportIndex].stack != "" && !hpLoading) {
      await loadSeriesIntoViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);
      rerenderViewport();
      // Re-assert HP WW/WL after the second load resets it to the natural window.
      const hpLayout = viewportHpLayout.get(viewportIndex);
      if (hpLayout && hpLayout.windowWidth && hpLayout.windowLevel) {
        setVOILUTRange(viewportIndex, hpLayout.windowWidth, hpLayout.windowLevel);
      }
    }
  };

  useEffect(() => {
    const handleThumbnailClick = async () => {
      if (
        viewportIndex === activeViewportIndex &&
        viewportSeriesData[viewportIndex].stack != "" && !hpLoading &&
        activeThumbnailIndex !== undefined
      ) {
        await loadSeriesIntoViewport(activeThumbnailIndex, activeViewportIndex);
      }
    };
    if (!dragEvent) {
      handleThumbnailClick();
    }
  }, [viewportSeriesData]);

  useEffect(() =>{
    if(hpLoading){
      setLoaderRunning(true);
      ref.current.continuousStart();
    }
  },[hpLoading])

  useEffect(() => {
    const handleHPLoading = async () => {
      if (
        hpLoading &&
        viewportSeriesData[viewportIndex].stack != ""
      ) {
        setViewportLoaderRunning(true);

        const firstValidIndex = viewportSeriesData.findIndex(
          (v) => v.stack !== ""
        );
        
        if(firstValidIndex === viewportIndex){
          setActiveModality(viewportSeriesData[viewportIndex].modality);
          changeActiveThumbnailIndex(viewportSeriesData[viewportIndex].thumbnailIndex);
          setActiveViewportModality(viewportModality);
          changeActiveViewportIndex(viewportIndex);
          let studyIdString = viewportSeriesData[viewportIndex].study;
          let studyIdInteger = parseInt(studyIdString, 10);
          setActiveStudyId(studyIdInteger);
        }
        setViewportModality(viewportSeriesData[viewportIndex].modality);
        if (viewportSeriesData[viewportIndex].modality === "SR") {
          generateSRReport(
            viewportSeriesData[viewportIndex].stack.thumbnailImageIds[0],
            setSRReport
          );
          setTimeout(() => {
            setViewportLoaderRunning(false);
            if (viewportIndex === 0) setImageLoadedOnViewport(true);
          }, 1000);
          const lastValidViewportIndex = viewportSeriesData.findLastIndex(
            (viewport) => viewport.stack !== ""
          );
          setTimeout(() => {
            if(lastValidViewportIndex == viewportIndex){
              resizeViewport();
              setActiveTool(cornerstonetools.WindowLevelTool.toolName);
              setHpLoading(false);
              ref.current.complete();
            }
          }, 600);
          return;
        }
        setViewportLoaded(true);
        await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);

        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        setViewportLoaded(true);
        setHPSeriesDataLoaded(true);
        setViewportLoadingComplete(true);

        // Re-assert HP WW/WL after loadViewport resets it to the natural window.
        const hpLayout = viewportHpLayout.get(viewportIndex);
        if (hpLayout && hpLayout.windowWidth && hpLayout.windowLevel) {
          setVOILUTRange(viewportIndex, hpLayout.windowWidth, hpLayout.windowLevel);
        }
      }
    };
    if (!dragEvent) {
        handleHPLoading();
    }
  }, [viewportSeriesData, hpLoading]);

  // Auto-load series mode: load series into this viewport when isAutoLoadLayout is set
  useEffect(() => {
    const handleAutoLoad = async () => {
      if (
        isAutoLoadLayout &&
        viewportSeriesData[viewportIndex]?.stack &&
        viewportSeriesData[viewportIndex].stack !== ""
      ) {
        setViewportLoaderRunning(true);

        const firstValidIndex = viewportSeriesData.findIndex(v => v.stack !== "");
        if (firstValidIndex === viewportIndex) {
          setActiveModality(viewportSeriesData[viewportIndex].modality);
          changeActiveThumbnailIndex(viewportSeriesData[viewportIndex].thumbnailIndex);
          setActiveViewportModality(viewportSeriesData[viewportIndex].modality);
          changeActiveViewportIndex(viewportIndex);
          const studyIdInteger = parseInt(viewportSeriesData[viewportIndex].study, 10);
          setActiveStudyId(studyIdInteger);
        }
        setViewportModality(viewportSeriesData[viewportIndex].modality);

        await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);

        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        setViewportLoaded(true);
        setViewportLoadingComplete(true);
        setViewportLoaderRunning(false);

        const lastValidViewportIndex = viewportSeriesData.findLastIndex(
          v => v.stack !== ""
        );
        if (lastValidViewportIndex === viewportIndex) {
          setTimeout(() => {
            resizeViewport();
            setIsAutoLoadLayout(false);
            setLoaderRunning(false);
            ref.current.complete();
          }, 600);
        }
      }
    };
    handleAutoLoad();
  }, [isAutoLoadLayout]);

  const applyViewportLayout = (viewportIndex) => {
    const layout = viewportHpLayout.get(viewportIndex);
    if (!layout) return;

    
    if (layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE) {
      FlipHorizontally(viewportIndex);
    }
    
    if (layout.flipVertically === HP_VIEWPORT_FLIP.ENABLE) {
      FlipVertically(viewportIndex);
    }
    if(layout.windowWidth && layout.windowLevel) {
      setVOILUTRange(viewportIndex, layout.windowWidth, layout.windowLevel);
    }
    
    setStackPosition(viewportIndex, layout.alignment, layout.rotation, layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE);
    setTimeout(() => {
      setRotation(viewportIndex, layout.rotation);
    }, 200);

    // Complete from the last viewport that has a layout entry (only these run applyViewportLayout); deriving it from viewportSeriesData stacks can point at a viewport with no layout, so the loader never stops.
    const layoutKeys = [...viewportHpLayout.keys()];
    const lastValidViewportIndex = layoutKeys.length ? Math.max(...layoutKeys) : viewportIndex;
    setTimeout(() => {
      if(lastValidViewportIndex == viewportIndex){
        resizeViewport();
        setActiveTool(cornerstonetools.WindowLevelTool.toolName);
        setHpLoading(false);
        ref.current.complete();
      }
    }, 600);
  };


  // const setHpCurrentImage = () => {
  //   startPrefetching();
  //   setViewportLoaderRunning(false);
  //     const imageIndex = viewportHpImage.get(viewportIndex); 
  //     if(imageIndex){
  //       setCurrentImage(imageIndex);
  //       setImageIndex(viewportIndex, imageIndex);
  //     }
  //     const lastValidViewportIndex = viewportSeriesData.findLastIndex(
  //       (viewport) => viewport.stack !== ""
  //     );
  //     setTimeout(() => {
  //       if(lastValidViewportIndex == viewportIndex){
  //         resizeViewport();
  //         setHpLoading(false);
  //         ref.current.complete();
  //       }
  //     }, 500);
  // };

  useEffect(() => {
    if(viewportHpLayout && viewportHpLayout.size > 0 && hpLoading && viewportLoaded && hpSeriesDataLoaded){
      // setTimeout(() => applyViewportLayout(viewportIndex), 1000);
      applyViewportLayout(viewportIndex);
      // setHpCurrentImage();
    }
  }, [viewportHpLayout, hpLoading, viewportLoaded, hpSeriesDataLoaded]);
   
  //start stop prefetch
  const startPrefetching = async () => {
    if (viewportModality != "SR") {
      await prefetchData(viewportSeriesData[viewportIndex].thumbnailIndex);
    }
  };

  const onChange = useCallback((event) => {
    const intValue = parseInt(event.target.value, 10);
    lastUserScrollSourceRef.current = {
      viewportIndex,
      timestamp: Date.now(),
    };
    // Guard: only proceed if viewportSeriesData and image list are valid
    const seriesData = viewportSeriesData?.[viewportIndex];
    const seriesImageIds = seriesData?.stack?.thumbnailImageIds;
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      // Data not ready, do nothing
      return;
    }
    const safeTargetIndex = Math.max(0, Math.min(intValue, seriesImageIds.length - 1));
    const imageId = seriesImageIds[safeTargetIndex];
    if (imageId && cache.getImage(imageId)) {
      clearScrollImageLoader();
      updateViewport(viewportIndex, intValue);
      signalSyncTargetLoaders(intValue);
    } else {
      setScrollLoaderForIndex(intValue, null, true);
      updateViewport(viewportIndex, intValue);
      signalSyncTargetLoaders(intValue);
    }
  }, [viewportIndex, signalSyncTargetLoaders, setScrollLoaderForIndex, viewportSeriesData, clearScrollImageLoader]);

  const playCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.playClip(element, { framesPerSecond: cINEFramesPerSecond });
  };

  const pauseCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.stopClip(element);
  };

  const isActiveOrFullScreenViewport = activeViewportIndex === viewportIndex || viewportDoubleClickIndex === viewportIndex;

  useEffect(() => {
    if (isActiveOrFullScreenViewport) {
      if (isCineEnabled) {
        if (viewportLevelCINEEnabled) {
          playCINE();
        } else {
          pauseCINE();
        }
      } else {
        setViewportLevelCINEEnabled(true);
        pauseCINE();
      }
    } else {
      if (viewportLevelCINEEnabled) {
        pauseCINE();
        setViewportLevelCINEEnabled(true);
      }
    }
  }, [
    activeViewportIndex,
    viewportDoubleClickIndex,
    isCineEnabled,
    cINEFramesPerSecond,
    viewportLevelCINEEnabled,
  ]);

  useEffect(() => {
    setViewportLevelCINEEnabled(false);
  }, [activeThumbnailIndex]);

  // const onKeyPress = async (event) => {
  //   const keyCode = event.which;

  //   switch (keyCode) {

  //     case 27: //ESC
  //       if (activeTool === DEFAULT_TOOL) {
  //         break;
  //       }
  //       setPreviousActiveTool(activeTool);
  //       // setActiveTool(DEFAULT_TOOL);
  //       handleDefaultToolChange();
  //       break;
  //     case 73: //i -- INVERT
  //       setInvert(activeViewportIndex);
  //       break;
  //     case 72: //h -- HORIZONTAL FLIP
  //       FlipHorizontally(activeViewportIndex);
  //       break;
  //     case 86: //v -- VERTICAL FLIP
  //       FlipVertically(activeViewportIndex);
  //       break;
  //     case 48: //NORMAL WW WC
  //       resetVOILUTRange(activeViewportIndex, initialVOIRange);
  //       break;
  //     case 49: //CT ABDOMEN
  //       setVOILUTRange(activeViewportIndex, 400, 60);
  //       break;
  //     case 50: //CT ANGIO
  //       setVOILUTRange(activeViewportIndex, 600, 300);
  //       break;
  //     case 51: //CT BONE
  //       setVOILUTRange(activeViewportIndex, 1500, 300);
  //       break;
  //     case 52: //CT BRAIN
  //       setVOILUTRange(activeViewportIndex, 80, 40);
  //       break;
  //     case 53: //CT CHEST
  //       setVOILUTRange(activeViewportIndex, 400, 40);
  //       break;
  //     case 54: //CT LUNGS
  //       setVOILUTRange(activeViewportIndex, 1500, -400);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  useEffect(() => {
    // if (activeTool === DEFAULT_TOOL) {
    //   return;
    // }
    if (!viewportLoaded) {
      return;
    }
    
    setToolOnActiveViewport(
      viewportIndex,
      activeTool,
      previousActiveTool,
      activeViewportIndex,
      mouseButtonToolAssignments
    );
  }, [activeViewportIndex, activeThumbnailIndex]);

  const isRotatingRef = useRef(false);
  const startAngleRef = useRef(0);
  const startRotationRef = useRef(0);

  const getAngleFromCenter = (e, element) => {
    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    return Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);
  };

  useEffect(() => {
    if (activeTool !== "FreeRotate" || !viewportElement) return;

    // while FreeRotate is active, disable native touch gestures on the
    // viewport. Without this the browser hijacks the touch-drag as a scroll/zoom gesture and
    // fires pointercancel mid-drag, so rotation only advances in steps (user had to tap
    // repeatedly). touch-action:none hands us the full continuous drag for smooth rotation.
    const prevTouchAction = viewportElement.style.touchAction;
    viewportElement.style.touchAction = "none";

    // passive:false so preventDefault() can suppress any residual browser gesture handling.
    const listenerOpts = { capture: true, passive: false };

    const handlePointerDown = async (e) => {
      if (e.button !== 0) return;
      isRotatingRef.current = true;
      try { viewportElement.setPointerCapture(e.pointerId); } catch { /* ignore */ }
      startAngleRef.current = getAngleFromCenter(e, viewportElement);
      const currentRotation = await getViewportRotation(viewportIndex);
      startRotationRef.current = currentRotation;
      e.preventDefault();
      e.stopPropagation();
    };

    const handlePointerMove = async (e) => {
      if (!isRotatingRef.current) return;
      const currentAngle = getAngleFromCenter(e, viewportElement);
      const delta = currentAngle - startAngleRef.current;
      const newRotation = ((startRotationRef.current + delta) % 360 + 360) % 360;
      const rounded = Math.round(newRotation);
      setViewportRotation(rounded);
      await setRotationAbsolute(viewportIndex, rounded);
      e.preventDefault();
      e.stopPropagation();
    };

    const handlePointerUp = (e) => {
      isRotatingRef.current = false;
      try { viewportElement.releasePointerCapture(e.pointerId); } catch { /* ignore */ }
    };

    viewportElement.addEventListener("pointerdown", handlePointerDown, listenerOpts);
    viewportElement.addEventListener("pointermove", handlePointerMove, listenerOpts);
    viewportElement.addEventListener("pointerup", handlePointerUp, listenerOpts);
    viewportElement.addEventListener("pointercancel", handlePointerUp, listenerOpts);

    return () => {
      viewportElement.style.touchAction = prevTouchAction;
      viewportElement.removeEventListener("pointerdown", handlePointerDown, listenerOpts);
      viewportElement.removeEventListener("pointermove", handlePointerMove, listenerOpts);
      viewportElement.removeEventListener("pointerup", handlePointerUp, listenerOpts);
      viewportElement.removeEventListener("pointercancel", handlePointerUp, listenerOpts);
    };
  }, [activeTool, viewportElement, viewportIndex]);

  useEffect(() => {
    if (activeTool === "FreeRotate" && viewportLoaded) {
      getViewportRotation(viewportIndex)
        .then((r) => setViewportRotation(r || 0))
        .catch(() => setViewportRotation(0));
    }
  }, [activeTool, viewportLoaded]);

  useEffect(() => {
    if ((viewportIndex === 0 && viewportLoaded) || (hpLoading && viewportLoaded)) {
      setTimeout(async () => {
        setToolOnActiveViewport(
          viewportIndex,
          activeTool,
          previousActiveTool,
          activeViewportIndex,
          mouseButtonToolAssignments
        );
      }, 500); 
    }
  }, [viewportLoaded, hpLoading, mouseButtonToolAssignments]);

  useEffect(() => {
    if (!viewportLoaded || !isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    enableStackScrollSync(
      activeViewportIndex,
      syncMode,
      viewportSeriesData,
      linkedViewports.length > 0 ? linkedViewports : null
    );
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportLoaded,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (!viewportLoaded || viewportLoaderRunning) {
      return;
    }

    if (!isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    // When a dropped/selected series finishes loading, register sync again so
    // newly ready targets participate immediately (no delayed first sync).
    lastSignaledTargetIndexRef.current = {};
    enableStackScrollSync(
      activeViewportIndex,
      syncMode,
      viewportSeriesData,
      linkedViewports.length > 0 ? linkedViewports : null
    );
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportLoaded,
    viewportLoaderRunning,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (isSynchronizedEnabled && SYNC_EXCLUDED_MODALITIES.includes(viewportModality)) {
      disableStackScrollSync();
      setIsSynchronizedEnabled(false);
    }
  }, [viewportModality]);

  const setActive = (
    updateFromViewportSeriesData = true,
    droppedSeriesData = null
  ) => {
    if (isSynchronizedEnabled) {
      enableStackScrollSync(
        viewportIndex,
        syncMode,
        viewportSeriesData,
        linkedViewports.length > 0 ? linkedViewports : null
      );
    } else {
      disableStackScrollSync();
    }
    setActiveViewportModality(viewportModality);
    changeActiveViewportIndex(viewportIndex);
    if (viewportLoaded || droppedSeriesData) {
      const resolvedThumbnailIndex =
        droppedSeriesData?.thumbnailIndex ??
        viewportSeriesData[viewportIndex].thumbnailIndex;
      changeActiveThumbnailIndex(resolvedThumbnailIndex);
      if(updateFromViewportSeriesData) {

        setActiveModality(viewportSeriesData[viewportIndex].modality);
        let studyIdString = viewportSeriesData[viewportIndex].study;
        let studyIdInteger = parseInt(studyIdString, 10);
        setActiveStudyId(studyIdInteger);
      } else if (droppedSeriesData) {
        setActiveModality(droppedSeriesData.modality);
        const droppedStudyId = parseInt(droppedSeriesData.studyId, 10);
        if (!Number.isNaN(droppedStudyId)) {
          setActiveStudyId(droppedStudyId);
        }
      }
    } else {
      changeActiveThumbnailIndex(undefined);
    }

    if(boundingBoxAdding && boundingBoxAdding === "disabled" && activeTool === 'RectangleROI' && editWarning.success){
      handleRemoveWarning();
    }else{
      setBoundingBoxAdding("disabled");
    }    
  };

  const updateZoomedInViewportState = async () => {
    const viewport = await getViewport(viewportIndex);
    updateViewportProperties(viewportIndex, viewport);
  };

  const initializeAllViewportState = async () => {
    for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
      const viewport = await getViewport(viewportIndex);
      updateViewportProperties(viewportIndex, viewport);
    }
  };

  const showLargeImage = async () => {
    if(viewportLoaded && !isCineEnabled){
      if(!viewportOldState.largeImage){
        await initializeAllViewportState();
      }else{
        await updateZoomedInViewportState();
      }


    const activeViewport = await getViewport(activeViewportIndex);
    updateViewportProperties(activeViewportIndex, activeViewport);
        
      setViewportOldState((prevState) => ({
        ...prevState,
        viewportIndex: viewportIndex,
        // activeImageIndex: currentImage,
        isDoubleClicked: true,
        largeImage: !prevState.largeImage,
      })); 
    }
  };

  useEffect(() => {
    if (viewportOldState.isDoubleClicked && viewportOldState.viewportIndex === viewportIndex) {
      if (viewportOldState.largeImage) {

        const viewportMap = new Map();

        for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
            viewportMap.set(viewportIndex, false);
        }
        
        const allViewportOldStatus = Object.fromEntries(viewportMap);

        setViewportOldState((prevState) => ({
          ...prevState,
          reportMenu: reportMenu,
          seriesMenu: seriesMenu,
          showPathologyOptions: showPathologyOptions,
          viewportRow: viewportRow,
          viewportColumn: viewportColumn,
          isDoubleClicked: true,
          activeViewportIndex: activeViewportIndex,
          activeThumbnailIndex: viewportSeriesData[viewportIndex].thumbnailIndex,
          allViewportOldStatus: allViewportOldStatus,
          loadOldViewportStatus: true,
          viewportSeriesData: viewportSeriesData
        }));

        setReportMenu(false);
        setSeriesMenu(false);
       // setShowTopBar(false);
       // setShowSharedTopBar(false);
        setShowPathologyOptions(false);
        // setViewportRow(1);
        // setViewportColumn(1);
        setViewportDoubleClickIndex(viewportIndex);
        setViewportDoubleClickIndexConst(viewportIndex);
        
      } else {
        setReportMenu(viewportOldState.reportMenu);
        setSeriesMenu(viewportOldState.seriesMenu);
        setShowTopBar(true);
        setShowSharedTopBar(true);
        setShowPathologyOptions(viewportOldState.showPathologyOptions);
        // setViewportRow(viewportOldState.viewportRow);
        // setViewportColumn(viewportOldState.viewportColumn);
        setViewportOldState((prevState) => ({
          ...prevState,
          isDoubleClicked: false,
        }));
        setViewportDoubleClickIndex(-1);
        setViewportDoubleClickIndexConst(-1);

        setTimeout(async () => {
          await updateZoomedInViewportState();
          await resizeViewport();
        }, 350);
      }
    }
  }, [viewportOldState.largeImage, viewportOldState.viewportIndex]);

  useEffect(() =>{
    if(viewportDoubleClickIndex  === viewportIndex) {
      setTimeout(async () => {
        await resizeViewport();
        await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
        setViewerOpacity(1);
      }, 350);
    }
  }, [viewportDoubleClickIndex]);

  useEffect(() => {
    const handleDoubleClickReturn = async () => {
      if (viewportOldState && 
        viewportOldState.allViewportOldStatus && 
        !viewportOldState.allViewportOldStatus[viewportIndex] &&
        !viewportOldState.isDoubleClicked) {
        
        setViewportOldState((prevState) => {
          const updatedViewportStatus = { ...prevState.allViewportOldStatus };
          updatedViewportStatus[viewportIndex] = true;
          return {
            ...prevState,
            allViewportOldStatus: updatedViewportStatus,
          };
        });

        setTimeout(async () => {
          await resizeViewport();
          await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
          setViewerOpacity(1);
        }, 350);
      }
    };
    
    handleDoubleClickReturn();
  }, [viewportOldState]);

  useEffect(() => {
    const sbHeight = `${elementRef.current.clientHeight - 23}px`;
    setScrollbarHeight(() => {
      return sbHeight;
    });
  }, [viewportRow, viewportColumn, viewportElements]);

  useEffect(() => {
    if (activeViewportIndex === viewportIndex) {
      changeActiveThumbnailIndex(
        viewportSeriesData[viewportIndex].thumbnailIndex
      );
    }
  }, [viewportSeriesData]);

  const updateOriginalImageState = () => {
    resetOriginalImageState(originalImageActiveState, activeViewportIndex, setOriginalImageActiveState);
  };

  const handleDrop = async (e) => {
    const seriesData = extractSeriesDataFromDragEvent(e, viewportIndex);
    const nextViewportSeriesData = viewportSeriesData.map((data, i) => {
      if (i !== viewportIndex) return data;
      const { studyId, ...rest } = seriesData;
      return {
        ...rest,
        study: studyId,
      };
    });

    changeActiveThumbnailIndex(seriesData.thumbnailIndex);
    changeViewportSeriesDataUpdated(seriesData);
    setActive(false, seriesData);
    updateOriginalImageState();

    await loadSeriesIntoViewport(
      seriesData.thumbnailIndex,
      viewportIndex,
      seriesData.stack,
      {
        heatmapStack: seriesData.heatmapStack,
        outlineStack: seriesData.outlineStack,
        modality: seriesData.modality,
      }
    );

    if (isSynchronizedEnabled && syncMode !== SYNC_MODES.DISABLED) {
      enableStackScrollSync(
        viewportIndex,
        syncMode,
        nextViewportSeriesData,
        linkedViewports.length > 0 ? linkedViewports : null
      );
    }

    // Re-toggle reference lines after drop so the source viewport is
    // re-evaluated (e.g. if a topogram was dropped into the active viewport,
    // the source should switch to a multi-slice viewport instead).
    if (isReferenceLinesEnabled) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }

    setDragEvent(false);
    if (viewportElement) {
      viewportElement.focus();
      viewportElement.tabIndex = 0;
    }
  };

  useEffect(() => {
    const updateVOI = (event) => {
      const { range } = event.detail;

      if (!range) {
        return;
      }

      const { lower, upper } = range;
      const { windowWidth, windowCenter } = utilities.windowLevel.toWindowLevel(
        lower,
        upper
      );

      setVOI({
        windowWidth: windowWidth,
        windowCenter: windowCenter,
      });

      // A VOI change NOT from our own PR apply is the user windowing — record it as the
      // user's baseline so non-PR frames keep the user's own view (Bug 2).
      if (!isProgrammaticViewportChange()) {
        captureUserBaseline();
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(Enums.Events.VOI_MODIFIED, updateVOI);

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.VOI_MODIFIED,
          updateVOI
        );
      };
    }
  }, [viewportElement]);

  useEffect(() => {
    const cameraModifiedLister = async (event) => {
      // A camera change (zoom/pan) NOT from our own PR apply means the user is driving
      // the view — record it as the user's baseline so non-PR frames keep it (Bug 2).
      if (!isProgrammaticViewportChange()) {
        captureUserBaseline();
      }
      try {
        const m = await updateOrientationMarkers(
          event,
          "viewport_" + activeViewportIndex
        );
        getInitialZoom(viewportIndex, setScale, event);
        setMarkers(m);
      } catch (error) {
        console.error(error);
        return;
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.CAMERA_MODIFIED,
        cameraModifiedLister
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.CAMERA_MODIFIED,
          cameraModifiedLister
        );
      };
    }
  }, [viewportElement]);

  useEffect(() =>{
    if(activeModality === 'SR'){
      setIsSrSelected(true);
    }
  },[activeModality]);
  
  useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          performResize();
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);

  /*useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          await resetViewPlaneOfCamera(viewportIndex);
          setViewportFocusCalled(false);
          setTimeout(async () => {
            await resetViewPlaneOfCamera(viewportIndex);
            setViewportFocusCalled(false);
          }, 100);
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);*/

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  useEffect(() => {
    const loadSecondTime = async () => {
        if(viewportLoaded && viewportRendered){
          if(!viewportFocusCalled) {
            setViewportFocusCalled(true);

            // Reset/resize first to fix the "image as a line" Cornerstone 2.0 bug,
            // then await the second load so its applyPRToViewport runs last and
            // correctly restores the saved pan/zoom without being overwritten.
            let activeViewport = null;
            if (isMPRActive) {
              activeViewport = await getMPRViewport(viewportIndex);
            } else {
              activeViewport = await getViewport(viewportIndex);
            }
            activeViewport.resetCamera({
              resetPan: true,
              resetZoom: true,
              resetToCenter: true,
              storeAsInitialCamera: true,
            });
            activeViewport.resize();
            activeViewport.render();

            await handleLoadSecondTime();
          };
        }
      }

      loadSecondTime();
  },[viewportLoaded, viewportFocusCalled, viewportRendered]);

  useEffect(() => {
    setToolOnActiveViewport(
      viewportIndex,
      activeTool,
      previousActiveTool,
      activeViewportIndex,
      mouseButtonToolAssignments
    );
  }, [activeTool, mouseButtonToolAssignments]);

  const onDrag = async () => {
    if (activeTool === StackScrollTool.toolName) {
      setCurrentImage(await getCurrentImage(activeViewportIndex));
    }
  };

  function replaceWithBr() {
    return srReport.replace(/\n/g, "<br />");
  }

  const [impressionRight, setImpressionRight] = useState(10);
  const [impressionBottom, setImpressionBottom] = useState(
    showKeyImageStar ? 75 : 60
  );
  const [impressionTop, setImpressionTop] = useState(0);
  const handleDragStart = () => {
    // if (showCompare) setShowCompare(false);
  };

  const handleDragStop = (event, data) => {
    let { x, y } = data;
    let right = 10 - x;
    let bottom = 20 - y;

    let clientHeight = $("#viewport_" + viewportIndex).height();
    let clientWidth = $("#viewport_" + viewportIndex).width();
    let impressionHeight = clientHeight * 0.4;
    let impressionWidth = clientWidth * 0.4;

    if (right <= impressionWidth) {
      setImpressionRight(right);
    } else {
      setImpressionRight(right - impressionWidth + 10);
    }

    if (bottom + 50 >= impressionHeight) {
      if (showKeyImageStar) {
        setImpressionTop(clientHeight - bottom - 20);
        // setImpressionBottom(bottom - impressionHeight - 25);
        setImpressionBottom(0);
      } else {
        setImpressionTop(clientHeight - bottom - 35);
        // setImpressionBottom(bottom - impressionHeight - 40);
        setImpressionBottom(0);
      }
    } else {
      if (showKeyImageStar) {
        setImpressionTop(0);
        setImpressionBottom(bottom + 55);
      } else {
        setImpressionTop(0);
        setImpressionBottom(bottom + 40);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        impressionRef.current &&
        !impressionRef.current.contains(event.target)
      ) {
        setShowCompare(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  
  // useEffect(() => {
  //   const viewportElement = viewportRef.current;
  //   if (!viewportElement) return;

  //   const handlePointerDown = (event) => {
  //     // console.log("handlePointerDown");
  //     if (event.pointerType === "mouse") { 
  //       isDragging.current = false;

  //       rightClickTimer.current = setTimeout(() => {
  //         rightClickTimer.current = null;
  //       }, rightClickThreshold);
  //     }
  //   };

  //   const handlePointerMove = () => {
  //     // console.log("handlePointerMove");
  //     if (rightClickTimer.current !== null) {
  //       isDragging.current = true;
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   const handlePointerUp = (event) => {
  //     // console.log("handlePointerUp");
  //     if (event.pointerType === "mouse") {
  //       if (rightClickTimer.current !== null && !isDragging.current) {
  //         if(activeTool === "RectangleROI" && disableAddPathology){
  //           handleRemoveWarning();
  //         }
  //       }
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   if(activeTool === "RectangleROI" && disableAddPathology){
  //     viewportElement.addEventListener("pointerdown", handlePointerDown);
  //     viewportElement.addEventListener("pointermove", handlePointerMove);
  //     viewportElement.addEventListener("pointerup", handlePointerUp);
  //   }

  //   return () => {
  //     viewportElement.removeEventListener("pointerdown", handlePointerDown);
  //     viewportElement.removeEventListener("pointermove", handlePointerMove);
  //     viewportElement.removeEventListener("pointerup", handlePointerUp);
  //   };
  // }, [activeTool]);

  function convertToBase64(index, callback) {
    let viewport = document.querySelector(`#viewport_${index}`);
    let cornerstoneCanvas = viewport.querySelector("canvas");
    const svgLayer = document.getElementById("svg-layer-viewport_" + index);

    if (!cornerstoneCanvas || !svgLayer) {
        alert("Canvas or SVG layer not found!");
        return;
    }

    const canvasRect = cornerstoneCanvas.getBoundingClientRect();
    const svgRect = svgLayer.getBoundingClientRect();

    const tempCanvas = document.createElement("canvas");
    const ctx = tempCanvas.getContext("2d");

    tempCanvas.width = canvasRect.width;
    tempCanvas.height = canvasRect.height;
  
    ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

      // Clone and scale the SVG
      const clonedSvg = svgLayer.cloneNode(true);
      clonedSvg.setAttribute("width", canvasRect.width);
      clonedSvg.setAttribute("height", canvasRect.height);
      clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);

      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
      const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = function () {
        const xOffset = svgRect.left - canvasRect.left;
        const yOffset = svgRect.top - canvasRect.top;

        ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

        // Crop out black padding - find bounding box of non-black pixels
        const w = tempCanvas.width;
        const h = tempCanvas.height;
        const imageData = ctx.getImageData(0, 0, w, h);
        const pixels = imageData.data;
        const threshold = 10; // pixel brightness threshold to distinguish from black
        let top = h, left = w, bottom = 0, right = 0;

        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (pixels[i] > threshold || pixels[i + 1] > threshold || pixels[i + 2] > threshold) {
              if (y < top) top = y;
              if (y > bottom) bottom = y;
              if (x < left) left = x;
              if (x > right) right = x;
            }
          }
        }

        if (bottom > top && right > left) {
          const cropW = right - left + 1;
          const cropH = bottom - top + 1;
          const croppedCanvas = document.createElement("canvas");
          croppedCanvas.width = cropW;
          croppedCanvas.height = cropH;
          const croppedCtx = croppedCanvas.getContext("2d");
          croppedCtx.drawImage(tempCanvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
          const finalBase64 = croppedCanvas.toDataURL("image/png");
          if (callback) callback(finalBase64);
        } else {
          // Fallback: no cropping if detection fails
          const finalBase64 = tempCanvas.toDataURL("image/png");
          if (callback) callback(finalBase64);
        }
      };

      img.src = svgDataUrl;
  }

// Function to copy base64 to clipboard
async function copyToClipboard(index) {
  convertToBase64(index, async (base64Image) => {
      try {

          const response = await fetch(base64Image);
          const blob = await response.blob();
          const item = new ClipboardItem({ "image/png": blob });

          await navigator.clipboard.write([item]);
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-capture-button-text"));
          //alert("Image copied to clipboard!");
      } catch (err) {
          console.error("Failed to copy image:", err);
      }
  });
}



function flashViewport(index) {
  const viewport = document.querySelector(`#viewport_${index}`);
  if (!viewport) return;
  const flash = document.createElement("div");
  flash.style.cssText =
    "position:absolute;inset:0;background:#fff;opacity:0.85;pointer-events:none;z-index:9999;border-radius:inherit;transition:opacity 0.4s ease-out;";
  viewport.style.position = "relative";
  viewport.appendChild(flash);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      flash.style.opacity = "0";
    });
  });
  setTimeout(() => flash.remove(), 450);
}

async function handleUploadScDicom(index) {
  flashViewport(index);
  setViewportLoaderRunning(true);
  const seriesId = viewportSeriesData[index].stack.seriesId;
  const imageId = viewportSeriesData[index].stack.images[currentImage].id;
  let viewport = document.querySelector(`#viewport_${index}`);
  let cornerstoneCanvas = viewport.querySelector("canvas");
  const svgLayer = document.getElementById("svg-layer-viewport_" + index);

  if (!cornerstoneCanvas || !svgLayer) {
      alert("Canvas or SVG layer not found!");
      return;
  }

  // Clone the SVG to prevent modifications in the viewer
  const clonedSvg = svgLayer.cloneNode(true);

  // Get actual displayed size of canvas & SVG
  const canvasRect = cornerstoneCanvas.getBoundingClientRect();
  const svgRect = svgLayer.getBoundingClientRect();

  // Ensure SVG matches the actual canvas dimensions
  clonedSvg.setAttribute("width", canvasRect.width);
  clonedSvg.setAttribute("height", canvasRect.height);
  clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);

  // Convert SVG to base64
  const svgData = new XMLSerializer().serializeToString(clonedSvg);
  const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
  const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

  // Create a new canvas for merging images
  const tempCanvas = document.createElement("canvas");
  const ctx = tempCanvas.getContext("2d");

  // Use the ACTUAL displayed dimensions (not internal ones)
  tempCanvas.width = canvasRect.width;
  tempCanvas.height = canvasRect.height;

  // Draw the DICOM canvas first
  ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

  // Load and draw the SVG overlay
  const img = new Image();
  img.crossOrigin = "anonymous";

  img.onload = async function () {
      // Correcting offset positioning
      const xOffset = svgRect.left - canvasRect.left;
      const yOffset = svgRect.top - canvasRect.top;
      ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

      // Crop out black letterbox padding around the image
      const w = tempCanvas.width;
      const h = tempCanvas.height;
      const imageData = ctx.getImageData(0, 0, w, h);
      const pixels = imageData.data;
      const threshold = 10;
      let top = h, left = w, bottom = 0, right = 0;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const i = (y * w + x) * 4;
          if (pixels[i] > threshold || pixels[i + 1] > threshold || pixels[i + 2] > threshold) {
            if (y < top) top = y;
            if (y > bottom) bottom = y;
            if (x < left) left = x;
            if (x > right) right = x;
          }
        }
      }

      let outputCanvas = tempCanvas;
      if (bottom > top && right > left) {
        const cropW = right - left + 1;
        const cropH = bottom - top + 1;
        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = cropW;
        croppedCanvas.height = cropH;
        const croppedCtx = croppedCanvas.getContext("2d");
        croppedCtx.drawImage(tempCanvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
        outputCanvas = croppedCanvas;
      }

      // Convert final merged canvas to Base64
      const base64Data = outputCanvas.toDataURL("image/png").replace(/^data:image\/\w+;base64,/, "");

      // Upload the Base64 image
      try {
          const result = await uploadScDicom(base64Data,imageId);
          setViewportLoaderRunning(false);
          // The SC is ingested into object storage asynchronously, so it isn't renderable yet.
          // Just bump the popup badge and record it as pending; the popup fetches/polls and
          // auto-places it once ingestion completes. No immediate library fetch or placement.
          const newSopUid = result?.data?.data?.sopInstanceUid || result?.data?.sopInstanceUid;
          if (newSopUid && typeof markPendingCapture === "function") {
            markPendingCapture(newSopUid);
          }
          // The capture is never placed on a report at capture time. It simply lands in the SC
          // library; the Images popup decides where it renders (appended at the end of the report
          // by default, or distributed across reports when that flag is unticked). This keeps the
          // basic viewer and the MedDream advanced viewer (which captures server-side via STORESCP)
          // behaving identically.
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-clipboard-copy-button-text"));
          // Poll until the async DICOM ingestion finishes, then merge in just
          // the SC series (upsert — repeat captures replace the shared
          // "SC DICOM" series' stack in place), instead of refetching/rebuilding
          // the whole study structure — that full rebuild is what flashed the
          // viewport on every capture. Not awaited so the upload button
          // re-enables immediately.
          const newSeriesInstanceUid = result?.data?.data?.seriesInstanceUid || result?.data?.seriesInstanceUid;
          if (newSeriesInstanceUid && typeof waitForScSeriesAndMerge === "function") {
            waitForScSeriesAndMerge(newSeriesInstanceUid).then((mergeResult) => {
              if (!mergeResult?.success) {
                console.warn("[Viewport] SC DICOM series merge did not complete:", mergeResult);
              }
            });
          }
      } catch (error) {
          setViewportLoaderRunning(false);
          console.error("Upload failed:", error);
      }
  };

  img.src = svgDataUrl;
}

useEffect(() => {
  const listener = (e) => {
    if (e?.detail?.viewportIndex === viewportIndex) {
      handleUploadScDicom(viewportIndex);
    }
  };
  window.addEventListener("aug:request-sc-capture", listener);
  return () => window.removeEventListener("aug:request-sc-capture", listener);
}, [viewportIndex, currentImage, viewportSeriesData]);

// NEW: mobile "Copy to clipboard" support. The mobile toolbar (MobileMoreMenu)
// can't call copyToClipboard() directly because that handler lives here in
// Viewport.jsx. So, mirroring the existing "aug:request-sc-capture" pattern
// above, the mobile tile dispatches an "aug:request-copy" window event carrying
// the active viewportIndex, and the matching viewport handles it here.
useEffect(() => {
  const listener = (e) => {
    if (e?.detail?.viewportIndex === viewportIndex) {
      console.warn("::MOBILE-CAPTURE:: [Viewport] aug:request-copy received", {
        viewportIndex,
      });
      copyToClipboard(viewportIndex);
    }
  };
  window.addEventListener("aug:request-copy", listener);
  return () => window.removeEventListener("aug:request-copy", listener);
}, [viewportIndex, currentImage, viewportSeriesData]);



 return (
    <>
      <div
        className="viewport-parent-container h100 w100"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          className="viewport-container h100 w100"
          style={{
            position: viewportModality === "SR" ? "absolute" : "static",
            opacity: viewportModality === "SR" ? 0 : 1,
            pointerEvents: viewportModality === "SR" ? "none" : "auto",
            zIndex: viewportModality === "SR" ? -1 : "auto",
          }}
          
        >
          {/* {contextMenuOpen.open && (
            <ContextMenu
              mouseEvt={contextMenuOpen.mouseEvt}
              data={contextMenuOpen.data}
            />
          )} */}
  <div>

            </div>
          <div
            id={`viewport_${viewportIndex}`}
            className="cursor-pointer viewport-box h100 w100"
            //onKeyDown={onKeyPress}
            onClick={setActive}
            onDoubleClick={showLargeImage}
            // ref={viewportRef}
          >
           
            <div
              ref={elementRef}
              id="viewportEntry"
              className="h100 w100"
              style={{
                backgroundColor: 'black',
                cursor: activeTool === "FreeRotate" ? "crosshair" : undefined,
              }}
              onDrop={handleDrop}
              onDragOver={(e) => {
                e.preventDefault();
              }}
            ></div>
            {(isSpineLabellingActive || spineLabels?.length > 0) && (
              <SpineLabellingTool
                viewportIndex={viewportIndex}
                viewportElement={viewportElement}
              />
            )}

            {viewportLoaderRunning && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                  pointerEvents: "none",
                }}
              >
                <Spinner size={15} />
              </div>
            )}

            {!viewportLoaderRunning && scrollImageLoadState.loading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  height: "100%",
                  width: "100%",
                  zIndex: "99998",
                  position: "absolute",
                  top: "0",
                  background: "rgba(0, 0, 0, 0.82)",
                  pointerEvents: "none",
                }}
              >
                <Spinner size={12} />
                <span style={{ color: "#fff", fontSize: "11px" }}>
                  {t("studyviewer.scroll-image-loading", "Loading image")}
                </span>
              </div>
            )}

            <ImageScrollbar
              max={imageCount}
              // value={
              //   isSynchronizedEnabled ? synchronizedCurrentImage : currentImage
              // }
              // `currentImage` is already pinned to the OUTER (per-instance)
              // index during cine by the STACK_NEW_IMAGE handlers
              // (getCurrentOuterIndex), and for single-instance multiframe it
              // is left untouched while playing — so it is the correct
              // scrollbar position in every case. The old frozen-ref override
              // captured a stale currentImage (effect dep [viewportIndex]) and
              // snapped the thumb to the top during play.
              value={currentImage}
              onChange={onChange}
              //onKeyPress={onKeyPress}
              height={scrollbarHeight}
              elementRef={elementRef}
            />
            <MultiFrameToolbar viewportIndex={viewportIndex} />
            {showOverlay && viewportLoaded && (
              <>
                {getEnv("REACT_APP_VDC_PLATFORM") === "false" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <MobileOverlay
                      viewportData={viewportSeriesData[viewportIndex]}
                    />
                  )}
                {getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <>
                      <VDCMobileDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        isVDCMobileViewer={true}
                      />
                    </>
                  )}
                {!isMobile && viewportRow <= 2 && viewportColumn <= 2 && (
                  <div className="viewport-overlay-top-container">
                    <PatientDetails
                      viewportData={viewportSeriesData[viewportIndex]}
                      showForceReinference={showForceReinference}
                      forceReinference={forceReinference}
                      reportDoneStatusState={reportDoneStatusState}
                    />
                    <div className="viewport-overlay-right-column">
                      <StudyDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        viewportIndex={viewportIndex}
                      />
                      <SCDICOMDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        viewportIndex={viewportIndex}
                        copyToClipboard={copyToClipboard}
                        handleUploadScDicom={handleUploadScDicom}
                        //added for quality flag
                        currentImage={currentImage}
                      />
                      <ViewportSyncIndicator
                        viewportIndex={viewportIndex}
                        viewportModality={viewportModality}
                        lastSignaledTargetIndexRef={lastSignaledTargetIndexRef}
                      />
                    </div>
                  </div>
                )}

                {/* the desktop right column (above) is hidden on mobile,
                    so the Link Series icon never showed. Render just the sync
                    indicator on mobile, anchored top-right on the viewport. It
                    returns null unless Synchronize is enabled, so it only appears
                    when sync is on — same behaviour/conditions as desktop. */}
                {isMobile && (
                  <div
                    style={{
                      position: "absolute",
                      top: "44px",
                      right: "25px",
                      width: "25px",
                      display: "flex",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "auto",
                    }}
                  >
                    <ViewportSyncIndicator
                      viewportIndex={viewportIndex}
                      viewportModality={viewportModality}
                      lastSignaledTargetIndexRef={lastSignaledTargetIndexRef}
                    />
                  </div>
                )}

                {/* OLD: this SCDICOMDetails rendered unconditionally, so the
                     Copy / Secondary-Capture / Save-PR / Mark-KO buttons also
                     floated over the image on mobile.
                    NEW: on mobile these 4 actions live in the bottom "More"
                     menu (MobileMoreMenu) instead, so hide this desktop
                     viewport-overlay copy on mobile to avoid duplication.
                     Desktop is unchanged (isMobile === false → still renders).
                    Layouts with more than 2 rows/columns skip the
                     viewport-overlay-top-container block above (it renders
                     MobileOverlay/VDCMobileDetails instead), which also
                     dropped the right-column SCDICOMDetails. Render this
                     fallback copy only for that case, absolutely positioned
                     (viewport-overlay-sc-dicom-floating) so it isn't clipped
                     by the viewport's overflow:hidden — otherwise it renders
                     in normal document flow below the canvas and is invisible. */}
                {!isMobile && (viewportRow > 2 || viewportColumn > 2) && (
                  <div className="viewport-overlay-sc-dicom-floating">
                    <SCDICOMDetails
                      viewportData={viewportSeriesData[viewportIndex]}
                      viewportIndex={viewportIndex}
                      copyToClipboard={copyToClipboard}
                      handleUploadScDicom={handleUploadScDicom}
                    />
                  </div>
                )}
                <SeriesDetails
                  viewportData={viewportSeriesData[viewportIndex]}
                  // currentImage={
                  //   isSynchronizedEnabled
                  //     ? synchronizedCurrentImage
                  //     : currentImage
                  // }
                  currentImage={currentImage}
                  totalImage={imageCount}
                />
                <CalibrationBadge
                  viewportIndex={viewportIndex}
                  currentImage={currentImage}
                />
                {showCompare && isCompareActive && (
                  <div
                    // ref={impressionRef}
                    className="viewer-tool-more-dropdown"
                    style={{
                      position: "absolute",
                      height: "fit-content",
                      maxHeight: "40%",
                      width: "40%",
                      padding: "10px 10px 0px 10px",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "10px",
                      bottom: `${
                        impressionBottom === 0
                          ? "unset"
                          : impressionBottom + "px"
                      }`,
                      right: `${impressionRight}px`,
                      top: `${
                        impressionTop === 0 ? "unset" : impressionTop + "px"
                      }`,
                    }}
                  >
                    <div
                      id={`impression-text-viewport-${viewportIndex}`}
                      className="modal-scroll"
                      style={{
                        flex: 1,
                        overflowY: "auto",
                        minHeight: 0,
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          impressions[
                            "study_" + viewportSeriesData[viewportIndex].study
                          ]?.impressionText,
                      }}
                    >
                      {/* {
                        impressions[
                          "study_" + viewportSeriesData[viewportIndex].study
                        ]?.impressionText
                      } */}
                    </div>
                    <div
                      className="cursor-pointer"
                      style={{
                        flexShrink: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingBottom: "10px",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        var r = document.createRange();
                        r.selectNode(
                          document.getElementById(
                            `impression-text-viewport-${viewportIndex}`
                          )
                        );
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(r);
                        document.execCommand("copy");
                        window.getSelection().removeAllRanges();
                        // let copyText = document.getElementById(
                        //   `impression-text-viewport-${viewportIndex}`
                        // );
                        // navigator.clipboard.writeText(copyText.innerHTML);
                        showToastv2(TOAST_TYPE.SUCCESS, "Copied to clipboard!");
                      }}
                    >
                      <Copy />
                    </div>
                  </div>
                )}
                {isCompareActive && (
                  <Draggable
                    bounds="parent"
                    onStop={handleDragStop}
                    onStart={handleDragStart}
                    offsetParent={viewportElement}
                    nodeRef={draggableRef}
                  >
                    <div
                      ref={draggableRef}
                      style={{
                        position: "absolute",
                        bottom: showKeyImageStar ? "35px" : "20px",
                        right: "50px",
                      }}
                      onClick={() => {
                        setShowCompare((prev) => !prev);
                      }}
                      onMouseEnter={() => setImpressionHover(true)}
                      onMouseLeave={() => setImpressionHover(false)}
                    >
                      <Impression
                        color={
                          showCompare || impressionHover
                            ? theme.palette.activeTool
                            : theme.palette.inactiveTool
                        }
                      />
                    </div>
                  </Draggable>
                )}
                <ViewportNavWidget
                  viewportIndex={viewportIndex}
                  currentImageIndex={currentImage}
                  viewportLoaded={viewportLoaded}
                  priors={priors}
                  prAppliedCount={prAppliedCount}
                  currentStack={
                    viewportSeriesData[viewportIndex]?.stack?.modality !== "PR" &&
                    viewportSeriesData[viewportIndex]?.stack?.modality !== "SR"
                      ? viewportSeriesData[viewportIndex]?.stack
                      : null
                  }
                  slicePRItems={
                    currentSopUID
                      ? prItems.filter((item) => {
                          const prData = getCachedPRData(item.url);
                          return prData?.referencedSOPInstanceUIDs?.some(
                            (u) => u?.trim() === currentSopUID
                          );
                        })
                      : []
                  }
                  sliceKOItems={(() => {
                    const all = getAllCachedKOData();
                    if (!currentSopUID) return [];
                    const matched = all.filter((ko) =>
                      ko.referencedSOPInstanceUIDs?.some(
                        (u) => u?.trim() === currentSopUID
                      ),
                    );
                    return matched.map((ko) => ({
                      title:       ko.title,
                      description: ko.description,
                      creatorName: ko.creatorName,
                      date:        ko.creationDate,
                    }));
                  })()}
                  onPRToggle={handlePRToggle}
                  onPRToggleAll={handlePRToggleAll}
                />
              {  <DICOMDetails
                  voi={voi}
                  scale={scale}
                  showKeyImageStar={showKeyImageStar}
                  rotation={activeTool === "FreeRotate" ? viewportRotation : null}
                />  }
                <OrientationMarkers markers={markers} />



                {editWarning.show &&
                  viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MarkWarning
                      success={editWarning.success}
                      handleRemoveWarning={handleRemoveWarning}
                      pathalogyName={editWarning.name}
                      backgroundColor={editWarning.color}
                      id={editWarning.id}
                    />
                  )}
                  {/* {
                  enableLlmReport && isAgenticTab && isImageAllowedToLLM(studyModality, studyDescription) && viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MaskImage
                      show={maskingConfirm.show}
                      success={maskingConfirm.success}
                      backgroundColor={maskingConfirm.color}
                      maskImages = {maskImages}
                      currentImage= {currentImage}
                      viewportIndex = {viewportIndex}
                      activeThumbnailIndex= {viewportSeriesData[viewportIndex].thumbnailIndex}
                      id={maskingConfirm.id}
                    />
                  )} */}
              </>
            )}
            {isCineEnabled && (activeViewportIndex === viewportIndex || viewportDoubleClickIndex === viewportIndex) && (
              <>
                <div className="viewport-cine-container" style={!isMobile && window.innerHeight > window.innerWidth ? { bottom: "60px" } : undefined}>
                  <div className="viewport-cine-box">
                    <span
                      className="viewport-cine-button"
                      style={{ marginRight: "10px" }}
                      onClick={() =>
                        setViewportLevelCINEEnabled(!viewportLevelCINEEnabled)
                      }
                    >
                      {viewportLevelCINEEnabled ? (
                        <CINEPauseSmall />
                      ) : (
                        <CINEPlaySmall />
                      )}
                    </span>
                    <span
                      className={`viewport-cine-button ${
                        cINEFramesPerSecond === 1
                          ? "viewport-cine-button-disabled"
                          : ""
                      }`}
                      onClick={() => {
                        if (cINEFramesPerSecond !== 1) {
                          setCINEFramesPerSecond(cINEFramesPerSecond - 1);
                        }
                      }}
                    >
                      {" "}
                      <CINEMinus />{" "}
                    </span>
                    <span style={{color:"#ffffff"}}> {cINEFramesPerSecond} </span>
                    {/* <span className="viewport-cine-framepersecond-button">{cINEFramesPerSecond}</span> */}
                    <span
                      className="viewport-cine-button"
                      onClick={() =>
                        setCINEFramesPerSecond(cINEFramesPerSecond + 1)
                      }
                    >
                      {" "}
                      <CINEPlus />{" "}
                    </span>
                  </div>
                </div>
              </>
            )}
            {!viewportLoaderRunning && !viewportLoaded && (
              <>
                <div
                  className="viewport-empty-message h100 w100"
                  onDrop={handleDrop}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span>{t(isMobile ? "studyviewer.empty-viewport-message-mobile" : "studyviewer.empty-viewport-message")}</span>
                </div>
              </>
            )}
          </div>
        </div>
        {viewportModality === "SR" && (
          <div
            className="viewport-sr-container h100 w100"
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onClick={setActive}
          >
            <div className="viewer-modal-scroll viewport-sr">
              <span
                dangerouslySetInnerHTML={{ __html: replaceWithBr() }}
              ></span>
            </div>
            {viewportLoaderRunning && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                }}
              >
                <Spinner size={15} />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(Viewport);
